import React, { useState, useEffect, useRef } from "react";
import { createClient } from "@supabase/supabase-js";

// ── SUPABASE CLIENT ───────────────────────────────────────────────────────────
const SUPABASE_URL = "https://zpkojlmwsuitvyxbyngf.supabase.co";
const SUPABASE_KEY = "sb_publishable_geo5t1ffPZ_8yayDTr4Rgg_NYaKWTI8";
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

const CSS = `
  @import url('https://fonts.bunny.net/css2?family=Inter:wght@300;400;500;600;700&family=Lora:ital,wght@0,600;1,400&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #f7f5f2;
    --surface: #ffffff;
    --surface2: #f0ede8;
    --border: #e8e2d9;
    --border2: #d4ccbf;
    --text: #1a1612;
    --text2: #6b6460;
    --text3: #9e9890;
    --teal: #0d9488;
    --teal-light: #e6faf7;
    --teal-mid: #5eead4;
    --amber: #d97706;
    --amber-light: #fef8ec;
    --green: #16a34a;
    --green-light: #f0fdf4;
    --red: #dc2626;
    --red-light: #fef2f2;
    --blue: #2563eb;
    --blue-light: #eff6ff;
    --purple: #7c3aed;
    --purple-light: #f5f3ff;
    --shadow: 0 1px 4px rgba(0,0,0,0.06), 0 2px 12px rgba(0,0,0,0.04);
    --shadow-md: 0 4px 16px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04);
    --radius: 12px;
    --radius-lg: 16px;
  }
  body { background: var(--bg); color: var(--text); font-family: 'Inter', sans-serif; font-size: 14px; line-height: 1.6; }

  .shell { display: flex; min-height: 100vh; }

  .sidebar {
    width: 232px; flex-shrink: 0;
    background: var(--surface);
    border-right: 1px solid var(--border);
    display: flex; flex-direction: column;
    position: fixed; top: 0; left: 0; bottom: 0;
    z-index: 10;
  }
  .sidebar-logo { padding: 22px 20px 18px; border-bottom: 1px solid var(--border); }
  .logo-mark { display: flex; align-items: center; gap: 10px; }
  .logo-icon { width: 34px; height: 34px; border-radius: 10px; background: linear-gradient(135deg, #0d9488, #0891b2); display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
  .logo-text { font-family: 'Lora', serif; font-size: 17px; font-weight: 600; color: var(--text); line-height: 1.2; }
  .logo-text span { color: var(--teal); }
  .logo-badge { display: inline-block; background: var(--teal-light); color: var(--teal); font-size: 9px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; padding: 2px 7px; border-radius: 20px; margin-top: 2px; }
  .sidebar-nav { flex: 1; padding: 12px 10px; overflow-y: auto; }
  .nav-section { margin-bottom: 20px; }
  .nav-section-label { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.1em; color: var(--text3); padding: 0 10px; margin-bottom: 4px; }
  .nav-item { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 8px; cursor: pointer; transition: all 0.15s; font-size: 13.5px; font-weight: 500; color: var(--text2); border: none; background: none; width: 100%; text-align: left; }
  .nav-item:hover { background: var(--bg); color: var(--text); }
  .nav-item.active { background: var(--teal-light); color: var(--teal); font-weight: 600; }
  .nav-item .ni-icon { width: 20px; text-align: center; font-size: 15px; }
  .nav-item .ni-badge { margin-left: auto; background: var(--teal); color: white; font-size: 10px; font-weight: 700; padding: 1px 7px; border-radius: 20px; }
  .sidebar-footer { padding: 16px; border-top: 1px solid var(--border); }
  .user-row { display: flex; align-items: center; gap: 10px; }
  .user-avatar { width: 34px; height: 34px; border-radius: 50%; background: linear-gradient(135deg, var(--teal), var(--blue)); display: flex; align-items: center; justify-content: center; color: white; font-size: 12px; font-weight: 700; flex-shrink: 0; }
  .user-name { font-size: 13px; font-weight: 600; }
  .user-plan { font-size: 11px; color: var(--teal); }

  .main { margin-left: 232px; flex: 1; display: flex; flex-direction: column; min-height: 100vh; }

  .topbar { background: var(--surface); border-bottom: 1px solid var(--border); padding: 14px 32px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 5; }
  .topbar-left h1 { font-family: 'Lora', serif; font-size: 20px; font-weight: 600; }
  .topbar-left p { font-size: 12px; color: var(--text2); margin-top: 1px; }
  .topbar-right { display: flex; align-items: center; gap: 10px; }
  .topbar-btn { background: var(--surface2); border: 1px solid var(--border); border-radius: 8px; padding: 7px 14px; font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 600; color: var(--text2); cursor: pointer; transition: all 0.15s; }
  .topbar-btn:hover { background: var(--border); color: var(--text); }
  .topbar-btn.primary { background: var(--teal); color: white; border-color: var(--teal); }
  .topbar-btn.primary:hover { background: #0b7a70; }
  .hamburger { display: none; background: none; border: none; cursor: pointer; font-size: 22px; padding: 4px 8px; color: var(--text); line-height: 1; }
  .sidebar-overlay { display: none; position: fixed; inset: 0; z-index: 9; background: rgba(0,0,0,0.45); }
  .sidebar-overlay.open { display: block; }
  .bottom-nav { display: none; position: fixed; bottom: 0; left: 0; right: 0; z-index: 20; background: var(--surface); border-top: 1px solid var(--border); padding: 6px 0 10px; grid-template-columns: repeat(5,1fr); }
  .bn-item { display: flex; flex-direction: column; align-items: center; gap: 2px; background: none; border: none; cursor: pointer; padding: 6px 4px; color: var(--text3); font-family: 'Inter', sans-serif; }
  .bn-item.active { color: var(--teal); }
  .bn-item .bn-icon { font-size: 20px; line-height: 1; }
  .bn-item .bn-label { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }

  .content { padding: 28px 32px; flex: 1; }

  .card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 22px; box-shadow: var(--shadow); }
  .card-title { font-size: 13px; font-weight: 600; color: var(--text); margin-bottom: 16px; display: flex; align-items: center; gap: 7px; }
  .card-title .ct-icon { font-size: 14px; }

  .g2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .g3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; }
  .g4 { display: grid; grid-template-columns: repeat(4,1fr); gap: 14px; }
  .span2 { grid-column: span 2; }
  .span3 { grid-column: span 3; }

  .metric { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); padding: 18px 20px; box-shadow: var(--shadow); }
  .metric-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: var(--text3); margin-bottom: 8px; }
  .metric-value { font-family: 'Lora', serif; font-size: 26px; font-weight: 600; line-height: 1; margin-bottom: 4px; }
  .metric-sub { font-size: 11px; color: var(--text3); }
  .metric-trend { display: inline-flex; align-items: center; gap: 3px; font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 20px; margin-top: 6px; }
  .up { background: var(--green-light); color: var(--green); }
  .down { background: var(--red-light); color: var(--red); }
  .neu { background: var(--surface2); color: var(--text2); }

  .field { margin-bottom: 14px; }
  .label { display: block; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.07em; color: var(--text3); margin-bottom: 5px; }
  .input { width: 100%; background: var(--surface2); border: 1px solid var(--border); border-radius: 8px; padding: 9px 12px; color: var(--text); font-family: 'Inter', sans-serif; font-size: 13.5px; transition: border-color 0.15s, box-shadow 0.15s; outline: none; }
  .input:focus { border-color: var(--teal); box-shadow: 0 0 0 3px rgba(13,148,136,0.1); background: var(--surface); }
  textarea.input { resize: vertical; min-height: 80px; }
  .input-row { display: flex; gap: 10px; }
  .input-row .field { flex: 1; }

  .btn { background: var(--teal); color: white; border: none; border-radius: 8px; padding: 10px 20px; font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s; width: 100%; }
  .btn:hover { background: #0b7a70; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(13,148,136,0.25); }
  .btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; box-shadow: none; }
  .btn-sm { padding: 7px 14px; font-size: 12px; width: auto; }
  .btn-ghost { background: var(--surface2); color: var(--text2); border: 1px solid var(--border); }
  .btn-ghost:hover { background: var(--border); color: var(--text); box-shadow: none; }
  .btn-amber { background: var(--amber); }
  .btn-amber:hover { background: #b45309; }

  .badge { display: inline-block; padding: 3px 9px; border-radius: 20px; font-size: 11px; font-weight: 600; }
  .badge-green { background: var(--green-light); color: var(--green); }
  .badge-amber { background: var(--amber-light); color: var(--amber); }
  .badge-red { background: var(--red-light); color: var(--red); }
  .badge-blue { background: var(--blue-light); color: var(--blue); }
  .badge-teal { background: var(--teal-light); color: var(--teal); }
  .badge-purple { background: var(--purple-light); color: var(--purple); }

  .ai-box { background: linear-gradient(135deg, #f0fdf9, #f7fffe); border: 1px solid rgba(13,148,136,0.2); border-radius: var(--radius); padding: 16px; margin-top: 14px; font-size: 13px; line-height: 1.7; color: var(--text); }
  .ai-box::after { content: "KI-generiert · Keine Anlage-, Steuer- oder Rechtsberatung · Eigenverantwortliche Entscheidung"; display: block; font-size: 10px; color: var(--text3); margin-top: 10px; padding-top: 8px; border-top: 1px dashed rgba(13,148,136,0.2); font-style: italic; }
  .ai-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--teal); font-weight: 700; margin-bottom: 8px; display: flex; align-items: center; gap: 5px; }
  .ai-loading { color: var(--text3); font-style: italic; }

  .divider { border: none; border-top: 1px solid var(--border); margin: 16px 0; }

  .row-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid var(--border); }
  .row-item:last-child { border-bottom: none; }
  .row-label { font-size: 13.5px; font-weight: 500; }
  .row-sub { font-size: 11px; color: var(--text3); margin-top: 1px; }
  .row-right { text-align: right; }
  .row-val { font-size: 14px; font-weight: 600; }

  .stat-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; margin-bottom: 14px; }
  .stat-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.07em; color: var(--text3); margin-bottom: 3px; }
  .stat-value { font-family: 'Lora', serif; font-size: 22px; font-weight: 600; }
  .stat-sub { font-size: 11px; color: var(--text3); margin-top: 1px; }
  .c-green { color: var(--green); }
  .c-amber { color: var(--amber); }
  .c-red { color: var(--red); }
  .c-teal { color: var(--teal); }
  .c-blue { color: var(--blue); }
  .c-purple { color: var(--purple); }
  .c-text { color: var(--text); }

  .empty { color: var(--text3); text-align: center; padding: 36px 0; font-size: 13px; }

  .chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
  .chip { background: var(--surface2); border: 1px solid var(--border); border-radius: 6px; padding: 4px 10px; font-size: 12px; color: var(--text2); cursor: pointer; transition: all 0.15s; }
  .chip:hover { background: var(--teal-light); color: var(--teal); border-color: var(--teal-mid); }

  .dots::after { content: '.'; animation: dots 1.2s infinite; }
  @keyframes dots { 0%{content:'.'} 33%{content:'..'} 66%{content:'...'} }

  .aff-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); padding: 18px; display: flex; flex-direction: column; gap: 12px; transition: all 0.2s; box-shadow: var(--shadow); }
  .aff-card:hover { border-color: var(--teal-mid); box-shadow: var(--shadow-md); transform: translateY(-2px); }
  .aff-header { display: flex; align-items: flex-start; gap: 12px; }
  .aff-icon { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
  .aff-name { font-size: 14px; font-weight: 700; }
  .aff-cat { font-size: 11px; color: var(--text3); margin-top: 1px; }
  .aff-rate { font-family: 'Lora', serif; font-size: 28px; font-weight: 600; }
  .aff-rate-sub { font-size: 11px; color: var(--text3); }
  .aff-features { list-style: none; }
  .aff-features li { font-size: 12px; color: var(--text2); padding: 3px 0; display: flex; align-items: center; gap: 6px; }
  .aff-features li::before { content: "✓"; color: var(--teal); font-weight: 700; font-size: 11px; }
  .aff-btn { display: block; text-align: center; background: var(--text); color: white; padding: 10px; border-radius: 8px; font-size: 12px; font-weight: 700; text-decoration: none; transition: background 0.15s; }
  .aff-btn:hover { background: var(--teal); }
  .aff-note { font-size: 10px; color: var(--text3); text-align: center; }

  .alloc-bar { height: 8px; border-radius: 4px; background: var(--surface2); overflow: hidden; margin: 6px 0; }
  .alloc-fill { height: 100%; border-radius: 4px; }

  ::-webkit-scrollbar { width: 5px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 3px; }

  @media (max-width: 768px) {
    .sidebar { transform: translateX(-100%); transition: transform 0.25s ease; }
    .sidebar.open { transform: translateX(0); }
    .sidebar-overlay.open { display: block; }
    .main { margin-left: 0; padding-bottom: 72px; }
    .topbar { padding: 10px 14px; gap: 8px; }
    .topbar-left h1 { font-size: 16px; }
    .topbar-left p { display: none; }
    .hamburger { display: block; }
    .content { padding: 12px 10px; }
    .g2 { grid-template-columns: 1fr; }
    .g3 { grid-template-columns: 1fr; }
    .g4 { grid-template-columns: 1fr 1fr; }
    .span2 { grid-column: span 1; }
    .span3 { grid-column: span 1; }
    .stat-grid { grid-template-columns: 1fr 1fr; }
    .metric { padding: 12px 14px; }
    .metric-label { font-size: 10px; }
    .metric-value { font-size: 20px; }
    .card { padding: 14px 12px; }
    .card-title { font-size: 12px; }
    .input-row { flex-direction: column; }
    .row-item { padding: 10px 0; }
    .bottom-nav { display: grid; }
    .btn { padding: 11px 16px; font-size: 13px; }
    .aff-card { padding: 14px; }
    .topbar-btn { display: none; }
  }
  @media (max-width: 400px) {
    .g4 { grid-template-columns: 1fr; }
    .stat-grid { grid-template-columns: 1fr; }
    .content { padding: 8px 6px; }
    .metric-value { font-size: 18px; }
  }
`;

// ── Helpers ───────────────────────────────────────────────────────────────────
const fmt = (n) => n ? new Intl.NumberFormat("de-DE").format(Math.round(n)) : "–";
const fmtEur = (n) => n ? `${fmt(n)} €` : "–";
const pct = (n) => n ? `${n.toFixed(2)} %` : "–";

function calcRendite({ kaufpreis, miete, nk, zinssatz, eigenkapital }) {
  const kp = parseFloat(kaufpreis) || 0;
  const m = parseFloat(miete) || 0;
  const nkP = parseFloat(nk) || 10;
  const zins = parseFloat(zinssatz) || 3.8;
  const ek = parseFloat(eigenkapital) || 20;
  const nebenkosten = kp * (nkP / 100);
  const gesamtkosten = kp + nebenkosten;
  const fremdkapital = gesamtkosten * ((100 - ek) / 100);
  const eigenkapitalBetrag = gesamtkosten * (ek / 100);
  const jahresmieteBrutto = m * 12;
  const jahresmieteNetto = jahresmieteBrutto * 0.8;
  const zinslast = fremdkapital * (zins / 100);
  const cashflow = jahresmieteNetto - zinslast;
  const bruttorendite = kp > 0 ? (jahresmieteBrutto / kp) * 100 : 0;
  const nettorendite = gesamtkosten > 0 ? (jahresmieteNetto / gesamtkosten) * 100 : 0;
  const eigenkapitalrendite = eigenkapitalBetrag > 0 ? (cashflow / eigenkapitalBetrag) * 100 : 0;
  const faktor = m > 0 ? kp / jahresmieteBrutto : 0;
  return { gesamtkosten, fremdkapital, eigenkapitalBetrag, jahresmieteBrutto, jahresmieteNetto, zinslast, cashflow, bruttorendite, nettorendite, eigenkapitalrendite, faktor };
}

async function askAI(prompt, system) {
  try {
    const res = await fetch("/api/ai", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ prompt, system })
    });
    if (!res.ok) throw new Error(`Fehler ${res.status}`);
    const d = await res.json();
    return d.text || "Keine Antwort erhalten.";
  } catch (err) {
    return `Fehler: ${err.message}. Bitte versuche es erneut.`;
  }
}

// ── ETF & KRYPTO DATENBANKEN ──────────────────────────────────────────────────
const ETF_DB = [
  // ── Welt-ETFs ──
  { name: "Vanguard FTSE All-World", ticker: "VWCE", symbol: "VWCE.DE", typ: "ETF", ter: "0,22%" },
  { name: "iShares Core MSCI World", ticker: "IWDA", symbol: "IWDA.AS", typ: "ETF", ter: "0,20%" },
  { name: "Xtrackers MSCI World", ticker: "XDWD", symbol: "XDWD.DE", typ: "ETF", ter: "0,19%" },
  { name: "Lyxor MSCI World", ticker: "LCUW", symbol: "LCUW.DE", typ: "ETF", ter: "0,12%" },
  { name: "Amundi MSCI World", ticker: "CW8", symbol: "CW8.PA", typ: "ETF", ter: "0,38%" },
  { name: "SPDR MSCI World", ticker: "SWRD", symbol: "SWRD.AS", typ: "ETF", ter: "0,12%" },
  // ── S&P 500 ──
  { name: "iShares Core S&P 500", ticker: "CSPX", symbol: "CSPX.AS", typ: "ETF", ter: "0,07%" },
  { name: "Xtrackers S&P 500", ticker: "XDPD", symbol: "XDPD.DE", typ: "ETF", ter: "0,06%" },
  { name: "Vanguard S&P 500", ticker: "VUSD", symbol: "VUSD.AS", typ: "ETF", ter: "0,07%" },
  { name: "Invesco S&P 500", ticker: "SPXS", symbol: "SPXS.DE", typ: "ETF", ter: "0,05%" },
  { name: "Amundi S&P 500", ticker: "500", symbol: "500.PA", typ: "ETF", ter: "0,15%" },
  // ── NASDAQ ──
  { name: "iShares NASDAQ 100", ticker: "CNDX", symbol: "CNDX.AS", typ: "ETF", ter: "0,33%" },
  { name: "Invesco NASDAQ 100", ticker: "EQQQ", symbol: "EQQQ.DE", typ: "ETF", ter: "0,30%" },
  { name: "Xtrackers NASDAQ 100", ticker: "XNAS", symbol: "XNAS.DE", typ: "ETF", ter: "0,20%" },
  // ── Emerging Markets ──
  { name: "iShares MSCI Emerging Markets", ticker: "EIMI", symbol: "EIMI.DE", typ: "ETF", ter: "0,18%" },
  { name: "Xtrackers MSCI EM", ticker: "XMME", symbol: "XMME.DE", typ: "ETF", ter: "0,18%" },
  { name: "Vanguard FTSE EM", ticker: "VFEM", symbol: "VFEM.AS", typ: "ETF", ter: "0,22%" },
  // ── Europa ──
  { name: "Xtrackers MSCI Europe", ticker: "XMEU", symbol: "XMEU.DE", typ: "ETF", ter: "0,12%" },
  { name: "Lyxor Core STOXX 600", ticker: "MEUD", symbol: "MEUD.PA", typ: "ETF", ter: "0,07%" },
  { name: "iShares STOXX Europe 600", ticker: "EXSA", symbol: "EXSA.DE", typ: "ETF", ter: "0,20%" },
  { name: "Vanguard FTSE Europe", ticker: "VEUR", symbol: "VEUR.AS", typ: "ETF", ter: "0,10%" },
  // ── DAX ──
  { name: "Xtrackers DAX", ticker: "XDAX", symbol: "XDAX.DE", typ: "ETF", ter: "0,09%" },
  { name: "iShares Core DAX", ticker: "EXS1", symbol: "EXS1.DE", typ: "ETF", ter: "0,16%" },
  { name: "Lyxor DAX", ticker: "LYX0AB", symbol: "LYX0AB.DE", typ: "ETF", ter: "0,15%" },
  // ── Anleihen ──
  { name: "iShares Euro Govt Bond", ticker: "IEGA", symbol: "IEGA.AS", typ: "ETF", ter: "0,07%" },
  { name: "Vanguard EUR Govt Bond", ticker: "VGEA", symbol: "VGEA.AS", typ: "ETF", ter: "0,07%" },
  { name: "iShares EM Govt Bond", ticker: "SEMB", symbol: "SEMB.AS", typ: "ETF", ter: "0,45%" },
  // ── Themen ──
  { name: "iShares Global Clean Energy", ticker: "IQQH", symbol: "IQQH.DE", typ: "ETF", ter: "0,65%" },
  { name: "iShares Global Healthcare", ticker: "IHCU", symbol: "IHCU.AS", typ: "ETF", ter: "0,40%" },
  { name: "iShares Automation & Robotics", ticker: "RBOT", symbol: "RBOT.AS", typ: "ETF", ter: "0,40%" },
  { name: "iShares Digital Security", ticker: "LOCK", symbol: "LOCK.AS", typ: "ETF", ter: "0,40%" },
  { name: "Global X Artificial Intelligence", ticker: "AIQ", symbol: "AIQ.AS", typ: "ETF", ter: "0,68%" },
  { name: "iShares Global Water", ticker: "IH2O", symbol: "IH2O.AS", typ: "ETF", ter: "0,65%" },
  // ── US Aktien ──
  { name: "Apple Inc.", ticker: "AAPL", symbol: "AAPL", typ: "Aktie" },
  { name: "Microsoft Corp.", ticker: "MSFT", symbol: "MSFT", typ: "Aktie" },
  { name: "Amazon.com Inc.", ticker: "AMZN", symbol: "AMZN", typ: "Aktie" },
  { name: "Alphabet Inc. (Google)", ticker: "GOOGL", symbol: "GOOGL", typ: "Aktie" },
  { name: "NVIDIA Corp.", ticker: "NVDA", symbol: "NVDA", typ: "Aktie" },
  { name: "Tesla Inc.", ticker: "TSLA", symbol: "TSLA", typ: "Aktie" },
  { name: "Meta Platforms", ticker: "META", symbol: "META", typ: "Aktie" },
  { name: "Berkshire Hathaway B", ticker: "BRK.B", symbol: "BRK-B", typ: "Aktie" },
  { name: "JPMorgan Chase", ticker: "JPM", symbol: "JPM", typ: "Aktie" },
  { name: "Johnson & Johnson", ticker: "JNJ", symbol: "JNJ", typ: "Aktie" },
  { name: "Visa Inc.", ticker: "V", symbol: "V", typ: "Aktie" },
  { name: "Exxon Mobil", ticker: "XOM", symbol: "XOM", typ: "Aktie" },
  { name: "Procter & Gamble", ticker: "PG", symbol: "PG", typ: "Aktie" },
  { name: "UnitedHealth Group", ticker: "UNH", symbol: "UNH", typ: "Aktie" },
  { name: "Home Depot", ticker: "HD", symbol: "HD", typ: "Aktie" },
  { name: "Mastercard Inc.", ticker: "MA", symbol: "MA", typ: "Aktie" },
  { name: "Eli Lilly", ticker: "LLY", symbol: "LLY", typ: "Aktie" },
  { name: "Broadcom Inc.", ticker: "AVGO", symbol: "AVGO", typ: "Aktie" },
  { name: "Costco Wholesale", ticker: "COST", symbol: "COST", typ: "Aktie" },
  { name: "Adobe Inc.", ticker: "ADBE", symbol: "ADBE", typ: "Aktie" },
  { name: "Netflix Inc.", ticker: "NFLX", symbol: "NFLX", typ: "Aktie" },
  { name: "Salesforce Inc.", ticker: "CRM", symbol: "CRM", typ: "Aktie" },
  { name: "AMD (Advanced Micro Devices)", ticker: "AMD", symbol: "AMD", typ: "Aktie" },
  { name: "Intel Corp.", ticker: "INTC", symbol: "INTC", typ: "Aktie" },
  { name: "PayPal Holdings", ticker: "PYPL", symbol: "PYPL", typ: "Aktie" },
  { name: "Pfizer Inc.", ticker: "PFE", symbol: "PFE", typ: "Aktie" },
  { name: "Walt Disney", ticker: "DIS", symbol: "DIS", typ: "Aktie" },
  { name: "Coca-Cola Co.", ticker: "KO", symbol: "KO", typ: "Aktie" },
  // ── Deutsche Aktien ──
  { name: "SAP SE", ticker: "SAP", symbol: "SAP.DE", typ: "Aktie" },
  { name: "Siemens AG", ticker: "SIE", symbol: "SIE.DE", typ: "Aktie" },
  { name: "Allianz SE", ticker: "ALV", symbol: "ALV.DE", typ: "Aktie" },
  { name: "Deutsche Telekom", ticker: "DTE", symbol: "DTE.DE", typ: "Aktie" },
  { name: "Volkswagen AG", ticker: "VOW3", symbol: "VOW3.DE", typ: "Aktie" },
  { name: "BMW AG", ticker: "BMW", symbol: "BMW.DE", typ: "Aktie" },
  { name: "Mercedes-Benz Group", ticker: "MBG", symbol: "MBG.DE", typ: "Aktie" },
  { name: "BASF SE", ticker: "BAS", symbol: "BAS.DE", typ: "Aktie" },
  { name: "Bayer AG", ticker: "BAYN", symbol: "BAYN.DE", typ: "Aktie" },
  { name: "Deutsche Bank", ticker: "DBK", symbol: "DBK.DE", typ: "Aktie" },
  { name: "Münchener Rück", ticker: "MUV2", symbol: "MUV2.DE", typ: "Aktie" },
  { name: "Infineon Technologies", ticker: "IFX", symbol: "IFX.DE", typ: "Aktie" },
  { name: "Airbus SE", ticker: "AIR", symbol: "AIR.PA", typ: "Aktie" },
  { name: "Daimler Truck", ticker: "DTG", symbol: "DTG.DE", typ: "Aktie" },
  { name: "Deutsche Post / DHL", ticker: "DHL", symbol: "DHL.DE", typ: "Aktie" },
  { name: "Adidas AG", ticker: "ADS", symbol: "ADS.DE", typ: "Aktie" },
  { name: "Heidelberg Materials", ticker: "HEIG", symbol: "HEIG.DE", typ: "Aktie" },
  { name: "Rheinmetall AG", ticker: "RHM", symbol: "RHM.DE", typ: "Aktie" },
  { name: "Zalando SE", ticker: "ZAL", symbol: "ZAL.DE", typ: "Aktie" },
  // ── Europäische Aktien ──
  { name: "ASML Holding", ticker: "ASML", symbol: "ASML.AS", typ: "Aktie" },
  { name: "LVMH Moët Hennessy", ticker: "MC", symbol: "MC.PA", typ: "Aktie" },
  { name: "Novo Nordisk", ticker: "NOVO-B", symbol: "NOVO-B.CO", typ: "Aktie" },
  { name: "Nestlé SA", ticker: "NESN", symbol: "NESN.SW", typ: "Aktie" },
  { name: "Roche Holding", ticker: "ROG", symbol: "ROG.SW", typ: "Aktie" },
  { name: "Hermès International", ticker: "RMS", symbol: "RMS.PA", typ: "Aktie" },
  { name: "Schneider Electric", ticker: "SU", symbol: "SU.PA", typ: "Aktie" },
  { name: "TotalEnergies SE", ticker: "TTE", symbol: "TTE.PA", typ: "Aktie" },
  { name: "Shell PLC", ticker: "SHEL", symbol: "SHEL.AS", typ: "Aktie" },
];

const KRYPTO_DB = [
  { name: "Bitcoin",          ticker: "BTC",   cgId: "bitcoin" },
  { name: "Ethereum",         ticker: "ETH",   cgId: "ethereum" },
  { name: "Solana",           ticker: "SOL",   cgId: "solana" },
  { name: "BNB",              ticker: "BNB",   cgId: "binancecoin" },
  { name: "XRP",              ticker: "XRP",   cgId: "ripple" },
  { name: "Cardano",          ticker: "ADA",   cgId: "cardano" },
  { name: "Avalanche",        ticker: "AVAX",  cgId: "avalanche-2" },
  { name: "Polkadot",         ticker: "DOT",   cgId: "polkadot" },
  { name: "Chainlink",        ticker: "LINK",  cgId: "chainlink" },
  { name: "Litecoin",         ticker: "LTC",   cgId: "litecoin" },
  { name: "Dogecoin",         ticker: "DOGE",  cgId: "dogecoin" },
  { name: "Shiba Inu",        ticker: "SHIB",  cgId: "shiba-inu" },
  { name: "Toncoin",          ticker: "TON",   cgId: "the-open-network" },
  { name: "TRON",             ticker: "TRX",   cgId: "tron" },
  { name: "Stellar",          ticker: "XLM",   cgId: "stellar" },
  { name: "Monero",           ticker: "XMR",   cgId: "monero" },
  { name: "Uniswap",          ticker: "UNI",   cgId: "uniswap" },
  { name: "Cosmos",           ticker: "ATOM",  cgId: "cosmos" },
  { name: "Hedera",           ticker: "HBAR",  cgId: "hedera-hashgraph" },
  { name: "Filecoin",         ticker: "FIL",   cgId: "filecoin" },
  { name: "VeChain",          ticker: "VET",   cgId: "vechain" },
  { name: "Algorand",         ticker: "ALGO",  cgId: "algorand" },
  { name: "Internet Computer",ticker: "ICP",   cgId: "internet-computer" },
  { name: "Aptos",            ticker: "APT",   cgId: "aptos" },
  { name: "Sui",              ticker: "SUI",   cgId: "sui" },
  { name: "Arbitrum",         ticker: "ARB",   cgId: "arbitrum" },
  { name: "Optimism",         ticker: "OP",    cgId: "optimism" },
  { name: "Render",           ticker: "RNDR",  cgId: "render-token" },
  { name: "Injective",        ticker: "INJ",   cgId: "injective-protocol" },
  { name: "Fetch.ai",         ticker: "FET",   cgId: "fetch-ai" },
];

// ── LIVE PRICE HOOKS ──────────────────────────────────────────────────────────

// FIX: useKryptoLive jetzt mit user-Positionen aus Supabase, nicht statische Daten
function useKryptoLiveForPositionen(positionen) {
  const [preise, setPreise] = useState({});
  const [lastUpdate, setLastUpdate] = useState(null);

  useEffect(() => {
    if (!positionen || positionen.length === 0) return;
    const ids = [...new Set(positionen.map(p => p.cg_id).filter(Boolean))].join(",");
    if (!ids) return;
    fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${ids}&vs_currencies=eur`)
      .then(r => r.json())
      .then(json => {
        const map = {};
        positionen.forEach(p => {
          if (p.cg_id && json[p.cg_id]) map[p.cg_id] = json[p.cg_id].eur;
        });
        setPreise(map);
        setLastUpdate(new Date());
      })
      .catch(() => {});
  }, [positionen.length]);

  return { preise, lastUpdate };
}

// ETF/Aktien: Live-Kurse via /api/prices (Yahoo Finance wie StockLens)
function useETFLive(positionen) {
  const [preise, setPreise] = useState({});
  const [lastUpdate, setLastUpdate] = useState(null);

  useEffect(() => {
    if (!positionen || positionen.length === 0) return;
    const symbols = [...new Set(positionen.map(p => p.symbol || p.ticker).filter(Boolean))];
    if (symbols.length === 0) return;
    fetch(`/api/prices?symbols=${symbols.join(",")}`)
      .then(r => r.json())
      .then(data => {
        const map = {};
        positionen.forEach(p => {
          const sym = p.symbol || p.ticker;
          if (sym && data[sym]?.price) map[p.ticker] = data[sym].price;
        });
        setPreise(map);
        setLastUpdate(new Date());
      })
      .catch(() => {});
  }, [positionen?.length]);

  return { preise, lastUpdate };
}

// ── NAV CONFIG ────────────────────────────────────────────────────────────────
const PAGES = [
  { id: "dashboard",       label: "Übersicht",              icon: "🏠", section: "Hauptmenü" },
  { id: "immo-calc",       label: "Rendite-Kalkulator",     icon: "🏗️", section: "Immobilien" },
  { id: "immo-bewertung",  label: "KI-Bewertung",           icon: "✨", section: "Immobilien" },
  { id: "immo-portfolio",  label: "Portfolio",              icon: "🏘️", section: "Immobilien" },
  { id: "immo-verwaltung", label: "Verwaltung",             icon: "📋", section: "Immobilien" },
  { id: "assets",          label: "Alle Assets",            icon: "📊", section: "Geldanlage" },
  { id: "etf",             label: "ETF & Aktien",           icon: "📈", section: "Geldanlage" },
  { id: "krypto",          label: "Krypto",                 icon: "₿",  section: "Geldanlage" },
  { id: "liquiditaet",     label: "Liquidität",             icon: "💰", section: "Geldanlage" },
  { id: "dividenden",      label: "Dividendenkalender",     icon: "📅", section: "Geldanlage" },
  { id: "vergleiche",      label: "Produktvergleiche",      icon: "🔍", section: "Geldanlage" },
  { id: "passiv",          label: "Passives Einkommen",     icon: "💸", section: "Analyse" },
  { id: "steuern",         label: "Steuern & FSA",          icon: "📋", section: "Analyse" },
  { id: "performance",     label: "Performance",            icon: "📉", section: "Analyse" },
  { id: "fire",            label: "FIRE-Rechner",           icon: "🔥", section: "Analyse" },
  { id: "ki-assistent",    label: "KI-Assistent",           icon: "🤖", section: "Tools", badge: "Pro" },
  { id: "feedback",         label: "Feedback & Bugs",        icon: "💬", section: "Tools" },
];

// ── AUTH HOOK ─────────────────────────────────────────────────────────────────
function useAuth() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listener immer zuerst registrieren
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) loadProfile(session.user.id);
      else { setProfile(null); setLoading(false); }
    });
    // URL-Token von growvly.de Landingpage
    const authParam = new URLSearchParams(window.location.search).get("auth");
    if (authParam) {
      try {
        const { a: access_token, r: refresh_token } = JSON.parse(atob(authParam));
        supabase.auth.setSession({ access_token, refresh_token });
      } catch(e) {}
      window.history.replaceState({}, "", window.location.pathname);
    } else {
      supabase.auth.getSession().then(({ data: { session } }) => {
        setUser(session?.user ?? null);
        if (session?.user) loadProfile(session.user.id);
        else setLoading(false);
      });
    }
    return () => subscription.unsubscribe();
  }, []);

  async function loadProfile(userId) {
    const { data } = await supabase.from("profiles").select("*").eq("id", userId).single();
    setProfile(data);
    setLoading(false);
  }

  return { user, profile, loading };
}

// ── DATA HOOKS ────────────────────────────────────────────────────────────────
function useUserData(table, userId) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [writeError, setWriteError] = useState("");

  useEffect(() => {
    if (!userId) return;
    supabase.from(table).select("*").eq("user_id", userId).order("created_at")
      .then(({ data: rows, error }) => {
        setData(rows || []);
        setLoading(false);
        if (error) console.error(`[${table}] load error:`, error.message);
      });
  }, [table, userId]);

  async function add(item) {
    setWriteError("");
    const { data: newRow, error } = await supabase.from(table).insert({ ...item, user_id: userId }).select().single();
    if (error) { setWriteError("Speichern fehlgeschlagen: " + error.message); return null; }
    if (newRow) setData(prev => [...prev, newRow]);
    return newRow;
  }

  async function remove(id) {
    setWriteError("");
    const { error } = await supabase.from(table).delete().eq("id", id);
    if (error) { setWriteError("Löschen fehlgeschlagen: " + error.message); return; }
    setData(prev => prev.filter(r => r.id !== id));
  }

  async function update(id, updates) {
    setWriteError("");
    const { data: updated, error } = await supabase.from(table).update(updates).eq("id", id).select().single();
    if (error) { setWriteError("Aktualisierung fehlgeschlagen: " + error.message); return; }
    if (updated) setData(prev => prev.map(r => r.id === id ? updated : r));
  }

  return { data, loading, add, remove, update, writeError };
}

// ── LOGIN / REGISTER SCREEN ───────────────────────────────────────────────────
function AuthScreen() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setSuccess("");
    if (mode === "register" && password !== confirmPw) {
      setError("Passwörter stimmen nicht überein."); return;
    }
    setLoading(true);
    if (mode === "login") {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError("Falsche E-Mail oder Passwort.");
    } else {
      const { error } = await supabase.auth.signUp({ email, password, options: { data: { name } } });
      if (error) setError(error.message);
      else setSuccess("Account erstellt! Du kannst dich jetzt einloggen.");
    }
    setLoading(false);
  }

  async function handleReset() {
    if (!email) { setError("Bitte E-Mail eingeben."); return; }
    await supabase.auth.resetPasswordForEmail(email, { redirectTo: "https://growvly-app.vercel.app" });
    setSuccess("Passwort-Reset E-Mail gesendet!");
  }

  const features = [
    { icon: "🏠", text: "Immobilien & Rendite-Kalkulator" },
    { icon: "📈", text: "ETF, Aktien & Krypto-Tracking" },
    { icon: "🔥", text: "FIRE-Rechner & Vermögensplan" },
    { icon: "🤖", text: "KI-Assistent (PRO)" },
  ];

  return (
    <>
      <style>{CSS}</style>
      <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "Inter, sans-serif" }}>
        {/* Logo */}
        <a href="https://growvly.de" style={{ fontFamily: "Lora, serif", fontSize: "26px", fontWeight: 600, color: "var(--text)", textDecoration: "none", marginBottom: "8px" }}>
          Grow<span style={{ color: "var(--teal)" }}>vly</span>
        </a>
        <p style={{ fontSize: 13, color: "var(--text2)", marginBottom: "28px", textAlign: "center" }}>
          Dein smartes Finanz-Dashboard für Vermögensaufbau
        </p>

        {/* Feature-Übersicht */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", maxWidth: 400, width: "100%", marginBottom: "20px" }}>
          {features.map(f => (
            <div key={f.icon} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10, padding: "10px 12px", display: "flex", alignItems: "center", gap: 8, boxShadow: "var(--shadow)" }}>
              <span style={{ fontSize: 16 }}>{f.icon}</span>
              <span style={{ fontSize: 12, color: "var(--text2)", fontWeight: 500, lineHeight: 1.3 }}>{f.text}</span>
            </div>
          ))}
        </div>

        {/* Login/Register Card */}
        <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 20, padding: "32px 28px", maxWidth: 400, width: "100%", boxShadow: "var(--shadow-md)" }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
            {["login", "register"].map(m => (
              <button key={m} onClick={() => { setMode(m); setError(""); setSuccess(""); setConfirmPw(""); }}
                style={{ flex: 1, padding: "9px", borderRadius: 8, border: "1.5px solid", cursor: "pointer", fontFamily: "Inter, sans-serif", fontSize: 13, fontWeight: 600, transition: "all 0.15s",
                  background: mode === m ? "var(--teal)" : "var(--surface2)",
                  color: mode === m ? "white" : "var(--text2)",
                  borderColor: mode === m ? "var(--teal)" : "var(--border)" }}>
                {m === "login" ? "Einloggen" : "Registrieren"}
              </button>
            ))}
          </div>
          {error && <div style={{ background: "var(--red-light)", border: "1px solid rgba(220,38,38,0.2)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "var(--red)", marginBottom: 16 }}>{error}</div>}
          {success && <div style={{ background: "var(--green-light)", border: "1px solid rgba(22,163,74,0.2)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "var(--green)", marginBottom: 16 }}>{success}</div>}
          <form onSubmit={handleSubmit}>
            {mode === "register" && (
              <div className="field">
                <label className="label">Name</label>
                <input className="input" type="text" placeholder="Max Muster" value={name} onChange={e => setName(e.target.value)} required />
              </div>
            )}
            <div className="field">
              <label className="label">E-Mail</label>
              <input className="input" type="email" placeholder="deine@email.de" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label className="label">Passwort</label>
              <div style={{ position: "relative" }}>
                <input className="input" type={showPw ? "text" : "password"} placeholder="min. 8 Zeichen" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} style={{ paddingRight: 40 }} />
                <button type="button" onClick={() => setShowPw(v => !v)}
                  style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 16, color: "var(--text3)", lineHeight: 1 }}>
                  {showPw ? "🙈" : "👁"}
                </button>
              </div>
            </div>
            {mode === "register" && (
              <div className="field">
                <label className="label">Passwort wiederholen</label>
                <div style={{ position: "relative" }}>
                  <input className="input" type={showConfirmPw ? "text" : "password"} placeholder="••••••••" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} required minLength={8} style={{ paddingRight: 40 }} />
                  <button type="button" onClick={() => setShowConfirmPw(v => !v)}
                    style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 16, color: "var(--text3)", lineHeight: 1 }}>
                    {showConfirmPw ? "🙈" : "👁"}
                  </button>
                </div>
              </div>
            )}
            <button className="btn" type="submit" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? <span className="dots">Laden</span> : mode === "login" ? "Einloggen →" : "Kostenlos starten →"}
            </button>
          </form>
          {mode === "login" && (
            <button onClick={handleReset} style={{ background: "none", border: "none", color: "var(--teal)", fontSize: 13, cursor: "pointer", marginTop: 14, width: "100%", fontFamily: "Inter, sans-serif" }}>
              Passwort vergessen?
            </button>
          )}
          {mode === "register" && (
            <p style={{ fontSize: 11, color: "var(--text3)", textAlign: "center", marginTop: 14, lineHeight: 1.5 }}>
              Deine Daten werden verschlüsselt gespeichert und nicht weitergegeben.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

// ── PROFIL SEITE ──────────────────────────────────────────────────────────────
function ProfilSeite({ user, profile, isPro, handleLogout }) {
  const [name, setName] = useState(profile?.name || "");
  const [newEmail, setNewEmail] = useState("");
  const [saved, setSaved] = useState(false);
  const [emailMsg, setEmailMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);

  async function saveProfile(e) {
    e.preventDefault();
    setLoading(true);
    await supabase.from("profiles").update({ name }).eq("id", user.id);
    setSaved(true); setLoading(false);
    setTimeout(() => setSaved(false), 2000);
  }

  async function changeEmail(e) {
    e.preventDefault();
    if (!newEmail || newEmail === user.email) { setEmailMsg("Bitte neue E-Mail eingeben."); return; }
    setEmailLoading(true); setEmailMsg("");
    const { error } = await supabase.auth.updateUser({ email: newEmail });
    if (error) setEmailMsg(`Fehler: ${error.message}`);
    else setEmailMsg("Bestätigungs-E-Mail an neue Adresse gesendet. Bitte bestätigen.");
    setEmailLoading(false);
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title"><span className="ct-icon">👤</span>Persönliche Daten</div>
        <form onSubmit={saveProfile}>
          <div className="field">
            <label className="label">Name</label>
            <input className="input" value={name} onChange={e => setName(e.target.value)} placeholder="Dein Name" />
          </div>
          <div className="field">
            <label className="label">E-Mail (aktuell)</label>
            <input className="input" value={user.email} disabled style={{ opacity: 0.6 }} />
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button className="btn" type="submit" disabled={loading}>{loading ? "Speichern..." : "Name speichern"}</button>
            {saved && <span style={{ fontSize: 13, color: "var(--green)" }}>✓ Gespeichert</span>}
          </div>
        </form>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title"><span className="ct-icon">✉️</span>E-Mail ändern</div>
        <form onSubmit={changeEmail}>
          <div className="field">
            <label className="label">Neue E-Mail-Adresse</label>
            <input className="input" type="email" placeholder="neue@email.de" value={newEmail} onChange={e => setNewEmail(e.target.value)} />
          </div>
          {emailMsg && <div style={{ fontSize: 13, padding: "8px 12px", borderRadius: 8, marginBottom: 12, background: emailMsg.startsWith("Fehler") ? "var(--red-light)" : "var(--green-light)", color: emailMsg.startsWith("Fehler") ? "var(--red)" : "var(--green)" }}>{emailMsg}</div>}
          <button className="btn btn-ghost" type="submit" disabled={emailLoading}>{emailLoading ? <span className="dots">Sende</span> : "E-Mail ändern"}</button>
        </form>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title"><span className="ct-icon">💳</span>Abo & Plan</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid var(--border)" }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Aktueller Plan</div>
            <div style={{ fontSize: 13, color: "var(--text3)" }}>{isPro ? "Growvly PRO" : "Growvly Free"}</div>
          </div>
          <span className={`badge ${isPro ? "badge-green" : "badge-amber"}`}>{isPro ? "Aktiv" : "Free"}</span>
        </div>
        {isPro ? (
          <div style={{ paddingTop: 14 }}>
            <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 12 }}>Abo über das Stripe-Kundenportal verwalten – kündigen, Zahlungsmethode ändern, Rechnungen herunterladen.</div>
            <button className="btn btn-ghost" onClick={async () => {
              try {
                const res = await fetch("/api/stripe-portal", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ email: user.email, returnUrl: "https://growvly-app.vercel.app" })
                });
                if (!res.ok) throw new Error("Portal nicht verfügbar");
                const { url } = await res.json();
                if (url) window.location.href = url;
                else throw new Error("Keine URL erhalten");
              } catch {
                alert("Das Portal konnte nicht geöffnet werden. Bitte schreib uns an support@growvly.de – wir helfen dir innerhalb von 24h.");
              }
            }}>
              Abo im Stripe-Portal verwalten →
            </button>
            <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 8 }}>Zum Kündigen: Portal öffnen → "Abmelden" klicken. Zugang bleibt bis Periodenende aktiv. Bei Problemen: support@growvly.de</div>
          </div>
        ) : (
          <div style={{ paddingTop: 14 }}>
            <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 12 }}>Upgrade auf PRO für KI-Berater, unbegrenzte Assets und monatliche Reports.</div>
            <div style={{ display: "flex", gap: 8 }}>
              <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" rel="noopener noreferrer" style={{ background: "var(--teal)", color: "white", padding: "9px 16px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none" }}>PRO – 9 €/Mo →</a>
              <a href="https://buy.stripe.com/cNi9AV4Bv5NOdEs5oN6Ri02" target="_blank" rel="noopener noreferrer" style={{ background: "var(--bg)", border: "1px solid var(--border)", color: "var(--text)", padding: "9px 16px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none" }}>Jährlich – 79 € →</a>
            </div>
          </div>
        )}
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title"><span className="ct-icon">🔐</span>Sicherheit</div>
        <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 12 }}>Passwort-Reset per E-Mail anfordern.</div>
        <button className="btn btn-ghost" onClick={async () => {
          const { error } = await supabase.auth.resetPasswordForEmail(user.email, { redirectTo: "https://growvly-app.vercel.app" });
          alert(error ? `Fehler: ${error.message}` : "Passwort-Reset E-Mail gesendet!");
        }}>Passwort ändern</button>
      </div>

      <div className="card">
        <div className="card-title"><span className="ct-icon">⎋</span>Account</div>
        <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 12 }}>Sicher aus Growvly ausloggen.</div>
        <button className="btn btn-ghost" onClick={handleLogout}>Ausloggen</button>
      </div>
    </div>
  );
}

// ── UPGRADE CARD ──────────────────────────────────────────────────────────────
function UpgradeCard({ feature = "dieses Feature" }) {
  return (
    <div style={{ background: "var(--surface)", border: "1.5px solid var(--teal)", borderRadius: 16, padding: 32, maxWidth: 520, margin: "40px auto", textAlign: "center", boxShadow: "var(--shadow-md)" }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>PRO Feature</div>
      <div style={{ fontSize: 14, color: "var(--text2)", marginBottom: 24, lineHeight: 1.6 }}>{feature} ist nur für Growvly PRO Nutzer verfügbar.</div>
      <div style={{ background: "var(--bg)", borderRadius: 12, overflow: "hidden", marginBottom: 24, border: "1px solid var(--border)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", background: "var(--text)", color: "white", padding: "10px 16px", fontSize: 12, fontWeight: 700 }}>
          <span style={{ textAlign: "left" }}>Feature</span><span>Free</span><span>PRO</span>
        </div>
        {[
          ["Immobilien", "1 Objekt", "Unbegrenzt"],
          ["ETF & Aktien", "3 Positionen", "Unbegrenzt"],
          ["Krypto", "2 Coins", "Unbegrenzt"],
          ["Liquidität", "❌", "✅"],
          ["KI-Assistent", "❌", "✅"],
          ["KI-Bewertung", "❌", "✅"],
          ["KI-Analysen", "❌", "✅"],
        ].map(([feat, free, pro]) => (
          <div key={feat} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", padding: "9px 16px", fontSize: 13, borderBottom: "1px solid var(--border)" }}>
            <span style={{ textAlign: "left", color: "var(--text2)" }}>{feat}</span>
            <span style={{ color: free === "❌" ? "var(--red)" : "var(--text2)" }}>{free}</span>
            <span style={{ color: "var(--teal)", fontWeight: 600 }}>{pro}</span>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ background: "var(--teal)", color: "white", padding: "12px 24px", borderRadius: 10, fontWeight: 700, fontSize: 14, textDecoration: "none" }}>PRO – 9 €/Mo →</a>
        <a href="https://buy.stripe.com/cNi9AV4Bv5NOdEs5oN6Ri02" target="_blank" style={{ background: "var(--bg)", color: "var(--text)", border: "1.5px solid var(--border)", padding: "12px 24px", borderRadius: 10, fontWeight: 700, fontSize: 14, textDecoration: "none" }}>Jährlich – 79 €/Jahr</a>
      </div>
      <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 10 }}>Jederzeit kündbar · Sofortzugang nach Zahlung</div>
    </div>
  );
}

// ── FEEDBACK VIEW ─────────────────────────────────────────────────────────────
function FeedbackView({ user }) {
  const [kategorie, setKategorie] = useState("Verbesserungsvorschlag");
  const [nachricht, setNachricht] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [verlauf, setVerlauf] = useState([]);

  useEffect(() => {
    supabase.from("feedback").select("*").eq("user_id", user.id).order("created_at", { ascending: false }).limit(5)
      .then(({ data }) => setVerlauf(data || []));
  }, [success]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!nachricht.trim()) return;
    setLoading(true); setError("");
    const { error: err } = await supabase.from("feedback").insert({
      user_id: user.id,
      email: user.email,
      kategorie,
      nachricht: nachricht.trim(),
    });
    if (err) {
      setError("Fehler beim Senden. Bitte versuche es erneut.");
    } else {
      setSuccess(true); setNachricht("");
      setTimeout(() => setSuccess(false), 4000);
    }
    setLoading(false);
  }

  const kategorien = ["Verbesserungsvorschlag", "Bug melden", "Lob", "Feature-Wunsch", "Sonstiges"];
  const katIcons = { "Verbesserungsvorschlag": "💡", "Bug melden": "🐛", "Lob": "⭐", "Feature-Wunsch": "✨", "Sonstiges": "💬" };

  return (
    <div style={{ maxWidth: 600 }}>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title"><span className="ct-icon">💬</span>Feedback & Bug-Meldung</div>
        <p style={{ fontSize: 13, color: "var(--text2)", marginBottom: 20, lineHeight: 1.6 }}>
          Dein Feedback hilft uns, Growvly besser zu machen. Melde Bugs, teile Ideen oder gib uns einfach Bescheid was dir gefällt.
        </p>

        {success && (
          <div style={{ background: "var(--green-light)", border: "1px solid rgba(22,163,74,0.2)", borderRadius: 8, padding: "12px 16px", fontSize: 13, color: "var(--green)", marginBottom: 16 }}>
            ✓ Danke für dein Feedback! Es wurde gespeichert.
          </div>
        )}
        {error && (
          <div style={{ background: "var(--red-light)", border: "1px solid rgba(220,38,38,0.2)", borderRadius: 8, padding: "12px 16px", fontSize: 13, color: "var(--red)", marginBottom: 16 }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">Kategorie</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 4 }}>
              {kategorien.map(k => (
                <button key={k} type="button" onClick={() => setKategorie(k)}
                  style={{ padding: "7px 14px", borderRadius: 20, border: "1.5px solid", cursor: "pointer", fontSize: 12, fontWeight: 600, transition: "all 0.15s", fontFamily: "Inter, sans-serif",
                    background: kategorie === k ? "var(--teal)" : "var(--surface2)",
                    color: kategorie === k ? "white" : "var(--text2)",
                    borderColor: kategorie === k ? "var(--teal)" : "var(--border)" }}>
                  {katIcons[k]} {k}
                </button>
              ))}
            </div>
          </div>
          <div className="field">
            <label className="label">Deine Nachricht</label>
            <textarea className="input" rows={5} placeholder={
              kategorie === "Bug melden"
                ? "Beschreibe den Bug: Was hast du gemacht? Was ist passiert? Was hättest du erwartet?"
                : kategorie === "Verbesserungsvorschlag"
                ? "Was könnte besser sein? Beschreibe deine Idee so konkret wie möglich."
                : "Schreib uns alles was du auf dem Herzen hast..."
            } value={nachricht} onChange={e => setNachricht(e.target.value)} required />
          </div>
          <button className="btn" type="submit" disabled={loading || !nachricht.trim()}>
            {loading ? <span className="dots">Senden</span> : "Feedback absenden →"}
          </button>
        </form>
      </div>

      {verlauf.length > 0 && (
        <div className="card">
          <div className="card-title"><span className="ct-icon">📋</span>Deine letzten Meldungen</div>
          {verlauf.map(f => (
            <div key={f.id} className="row-item">
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{katIcons[f.kategorie] || "💬"} {f.kategorie}</div>
                <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>{new Date(f.created_at).toLocaleDateString("de-DE")}</div>
                <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 4, lineHeight: 1.5 }}>{f.nachricht.length > 120 ? f.nachricht.slice(0, 120) + "…" : f.nachricht}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── MAIN APP ──────────────────────────────────────────────────────────────────
export default function App() {
  const { user, profile, loading } = useAuth();
  const [page, setPage] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) return (
    <>
      <style>{CSS}</style>
      <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Inter, sans-serif" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "Lora, serif", fontSize: 24, fontWeight: 600, marginBottom: 16 }}>Grow<span style={{ color: "var(--teal)" }}>vly</span></div>
          <div style={{ fontSize: 13, color: "var(--text3)" }}><span className="dots">Laden</span></div>
        </div>
      </div>
    </>
  );

  if (!user) return <AuthScreen />;

  // FIX 3: Don't render until profile is confirmed loaded (prevents PRO-flash for free users)
  const profileReady = profile !== null || !loading;
  const isPro = profileReady ? (profile?.plan === "pro") : false;

  const sections = [...new Set(PAGES.map(p => p.section))];
  const current = PAGES.find(p => p.id === page);

  async function handleLogout() {
    await supabase.auth.signOut();
  }

  const bottomPages = [
    { id: "dashboard",     icon: "🏠", label: "Home" },
    { id: "immo-portfolio",icon: "🏘️", label: "Immo" },
    { id: "etf",           icon: "📈", label: "ETF" },
    { id: "fire",          icon: "🔥", label: "FIRE" },
    { id: "feedback",      icon: "💬", label: "Feedback" },
  ];

  return (
    <>
      <style>{CSS}</style>
      <div className="shell">
        {/* Overlay */}
        <div className={`sidebar-overlay ${sidebarOpen ? "open" : ""}`} onClick={() => setSidebarOpen(false)} />

        <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="sidebar-logo">
            <div className="logo-mark">
              <div className="logo-icon">📡</div>
              <div>
                <div className="logo-text">Grow<span>vly</span></div>
                <div className="logo-badge">PRO</div>
              </div>
            </div>
          </div>
          <nav className="sidebar-nav">
            {sections.map(sec => (
              <div className="nav-section" key={sec}>
                <div className="nav-section-label">{sec}</div>
                {PAGES.filter(p => p.section === sec).map(p => (
                  <button key={p.id} className={`nav-item ${page === p.id ? "active" : ""}`} onClick={() => { setPage(p.id); setSidebarOpen(false); }}>
                    <span className="ni-icon">{p.icon}</span>
                    {p.label}
                    {p.badge && <span className="ni-badge">{p.badge}</span>}
                  </button>
                ))}
              </div>
            ))}
          </nav>
          <div className="sidebar-footer">
            {!isPro && (
              <div style={{ margin: "0 0 12px", background: "linear-gradient(135deg, var(--teal-light), #f0fffe)", border: "1px solid rgba(13,148,136,0.2)", borderRadius: 10, padding: "12px 14px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--teal)", marginBottom: 4 }}>⚡ Upgrade auf PRO</div>
                <div style={{ fontSize: 11, color: "var(--text2)", marginBottom: 10, lineHeight: 1.5 }}>KI-Berater, unbegrenzte Assets & mehr.</div>
                <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank"
                  style={{ display: "block", textAlign: "center", background: "var(--teal)", color: "white", padding: "7px", borderRadius: 7, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                  Jetzt upgraden →
                </a>
              </div>
            )}
            <div className="user-row" onClick={() => { setPage("profil"); setSidebarOpen(false); }} style={{ cursor: "pointer", borderRadius: 8, padding: "4px 6px", transition: "background 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--surface2)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <div className="user-avatar">{(profile?.name || user.email || "?")[0].toUpperCase()}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="user-name" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{profile?.name || user.email}</div>
                <div className="user-plan">{isPro ? "PRO · aktiv ✓" : "Free"} · Einstellungen</div>
              </div>
              <button onClick={e => { e.stopPropagation(); handleLogout(); }}
                style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 16, padding: "4px" }} title="Ausloggen">⎋</button>
            </div>
            <div style={{ marginTop: 10, textAlign: "center", fontSize: 11, color: "var(--text3)" }}>
              <a href="https://growvly.de/impressum.html" target="_blank" rel="noopener noreferrer" style={{ color: "var(--text3)", textDecoration: "none" }}>Impressum</a>
              {" · "}
              <a href="https://growvly.de/datenschutz.html" target="_blank" rel="noopener noreferrer" style={{ color: "var(--text3)", textDecoration: "none" }}>Datenschutz</a>
            </div>
          </div>
        </aside>

        <div className="main">
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(o => !o)}>☰</button>
            <div className="topbar-left">
              <h1>{current?.label}</h1>
              <p>Growvly {isPro ? "PRO" : "Free"} · {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</p>
            </div>
            <div className="topbar-right">
              <button className="topbar-btn" onClick={() => setPage("ki-assistent")}>
                🤖 {isPro ? "KI fragen" : "🔒 KI (PRO)"}
              </button>
            </div>
          </div>
          <div className="content">
            {page === "dashboard"       && <Dashboard setPage={setPage} user={user} isPro={isPro} />}
            {page === "immo-calc"       && <ImmoKalkulator isPro={isPro} />}
            {page === "immo-bewertung"  && (isPro ? <ImmoBewertung /> : <UpgradeCard feature="KI-Bewertung" />)}
            {page === "immo-portfolio"  && <ImmoPortfolio user={user} isPro={isPro} />}
            {page === "immo-verwaltung" && <ImmoVerwaltung user={user} />}
            {page === "assets"          && <AlleAssets setPage={setPage} user={user} />}
            {page === "etf"             && <ETFDashboard user={user} isPro={isPro} />}
            {page === "krypto"          && <KryptoDashboard user={user} isPro={isPro} />}
            {page === "liquiditaet"     && (isPro ? <LiquiditaetDashboard user={user} /> : <UpgradeCard feature="Liquiditäts-Tracking" />)}
            {page === "dividenden"      && <DividendenKalender user={user} isPro={isPro} />}
            {page === "vergleiche"      && <Vergleiche />}
            {page === "passiv"          && <PassivesEinkommen user={user} isPro={isPro} />}
            {page === "steuern"         && <SteuerModul user={user} isPro={isPro} />}
            {page === "performance"     && (isPro ? <PerformanceTracker user={user} /> : <UpgradeCard feature="Performance-Tracking" />)}
            {page === "fire"            && <FIRErechner user={user} isPro={isPro} />}
            {page === "ki-assistent"    && (isPro ? <KIAssistent user={user} profile={profile} /> : <UpgradeCard feature="Der KI-Assistent" />)}
            {page === "feedback"        && <FeedbackView user={user} />}
            {page === "profil"          && <ProfilSeite user={user} profile={profile} isPro={isPro} handleLogout={handleLogout} />}
          </div>
        </div>

        {/* Bottom Nav – nur Mobile */}
        <nav className="bottom-nav">
          {bottomPages.map(bp => (
            <button key={bp.id} className={`bn-item ${page === bp.id ? "active" : ""}`} onClick={() => setPage(bp.id)}>
              <span className="bn-icon">{bp.icon}</span>
              <span className="bn-label">{bp.label}</span>
            </button>
          ))}
        </nav>

      </div>
    </>
  );
}

// ── DASHBOARD ─────────────────────────────────────────────────────────────────
function Dashboard({ setPage, user, isPro }) {
  const { data: immobilien, add: addImmo }       = useUserData("immobilien", user?.id);
  const { data: etfPositionen, add: addEtf }     = useUserData("etf_positionen", user?.id);
  const { data: kryptoPositionen, add: addKrypto } = useUserData("krypto_positionen", user?.id);
  const { data: liquiditaet, add: addLiquid }    = useUserData("liquiditaet", user?.id);
  const { preise: kryptoPreise }   = useKryptoLiveForPositionen(kryptoPositionen);
  const [kiReport, setKiReport]    = useState("");
  const [kiLoading, setKiLoading]  = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [demoLoaded, setDemoLoaded]   = useState(false);

  async function loadDemoData() {
    setDemoLoading(true);
    await Promise.all([
      addImmo({ name: "Musterstraße 12, München", kaufpreis: 420000, aktueller_wert: 465000, miete: 1350, eigenkapital: 20, zinssatz: 3.5, nk: 10 }),
      addEtf({ ticker: "VWCE", name: "Vanguard FTSE All-World", anteile: 85, kaufkurs: 112.50 }),
      addEtf({ ticker: "CSPX", name: "iShares Core S&P 500", anteile: 40, kaufkurs: 498.00 }),
      addKrypto({ ticker: "BTC", name: "Bitcoin", menge: 0.12, kaufkurs: 52000, cg_id: "bitcoin" }),
      addLiquid({ name: "Tagesgeld ING", betrag: 15000, zinsen: 3.5 }),
    ]);
    setDemoLoading(false);
    setDemoLoaded(true);
  }

  const immoWert   = immobilien.reduce((s, p) => s + Math.max(0, (p.aktueller_wert || 0) - (p.restschuld || 0)), 0);
  const immoCashflow = immobilien.reduce((s, p) => s + (p.miete || 0) - (p.hausgeld || 0) - (p.nebenkosten || 0), 0);
  const immoMiete  = immobilien.reduce((s, p) => s + (p.miete || 0), 0);
  const etfWert    = etfPositionen.reduce((s, e) => s + ((e.anteile || 0) * (e.kaufkurs || 0)), 0);
  const kryptoWert = kryptoPositionen.reduce((s, k) => {
    const livePreis = k.cg_id && kryptoPreise[k.cg_id] ? kryptoPreise[k.cg_id] : (k.kaufkurs || 0);
    return s + (k.menge || 0) * livePreis;
  }, 0);
  const liquidWert = liquiditaet.reduce((s, l) => s + (l.betrag || 0), 0);
  const totalWert  = immoWert + etfWert + kryptoWert + liquidWert;

  async function generateReport() {
    setKiLoading(true);
    const info = `Gesamtvermögen: ${fmtEur(totalWert)}. Immobilien: ${immobilien.length} Objekte (${fmtEur(immoWert)}), Mieteinnahmen: ${fmtEur(immoMiete)}/Mo. ETF/Aktien: ${etfPositionen.length} Positionen (${fmtEur(etfWert)}). Krypto: ${kryptoPositionen.length} Coins (${fmtEur(kryptoWert)}). Liquidität: ${fmtEur(liquidWert)}.`;
    const text = await askAI(`Du bist ein hilfreicher Finanz-Assistent. Erstelle einen sachlichen Monats-Überblick: ${info}. Gib 3 informative Hinweise: Was läuft gut, was könnte optimiert werden, welche nächsten Schritte wären möglich? Hinweis am Ende: Diese Analyse ist keine Anlageberatung. Direkt und klar formuliert.`);
    setKiReport(text); setKiLoading(false);
  }

  return (
    <div>
      {totalWert === 0 && !demoLoaded && (
        <div style={{ padding: "20px 24px", background: "linear-gradient(135deg, var(--teal-light), #f0fffe)", border: "1px solid rgba(13,148,136,0.2)", borderRadius: 12, marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16, flexWrap: "wrap" }}>
            <span style={{ fontSize: 32 }}>👋</span>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>Willkommen bei Growvly!</div>
              <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 14 }}>
                Füge deine Assets manuell hinzu — oder lade erst Demo-Daten um die App direkt auszuprobieren.
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button className="btn btn-sm" onClick={loadDemoData} disabled={demoLoading}
                  style={{ background: "var(--teal)", color: "white" }}>
                  {demoLoading ? <span className="dots">Lade Demo</span> : "🎯 Mit Demo-Daten starten"}
                </button>
                <button className="btn btn-sm btn-ghost" onClick={() => setPage("immo-portfolio")}>
                  Eigene Daten eingeben →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {demoLoaded && (
        <div style={{ padding: "12px 18px", background: "var(--green-light)", border: "1px solid rgba(22,163,74,0.2)", borderRadius: 10, marginBottom: 16, fontSize: 13, color: "var(--green)" }}>
          ✓ Demo-Daten geladen! Erkunde das Dashboard und ersetze die Daten durch deine eigenen.
        </div>
      )}
      <div className="g4" style={{ marginBottom: 20 }}>
        <div className="metric"><div className="metric-label">Gesamtvermögen</div><div className="metric-value c-text">{fmtEur(totalWert)}</div><div className="metric-sub">Alle Asset-Klassen</div></div>
        <div className="metric"><div className="metric-label">Immobilien (netto)</div><div className="metric-value c-teal">{fmtEur(immoWert)}</div><div className="metric-sub">{immobilien.length} Objekte · nach Restschuld</div></div>
        <div className="metric"><div className="metric-label">ETF & Aktien</div><div className="metric-value c-blue">{fmtEur(etfWert)}</div><div className="metric-sub">{etfPositionen.length} Positionen</div></div>
        <div className="metric"><div className="metric-label">Immo-Cashflow</div><div className={`metric-value ${immoCashflow >= 0 ? "c-green" : "c-red"}`}>{fmtEur(immoCashflow)}</div><div className="metric-sub">nach Hausgeld & Kosten</div></div>
      </div>

      <div className="g2" style={{ marginBottom: 20 }}>
        <div className="card">
          <div className="card-title"><span className="ct-icon">🥧</span>Vermögensaufteilung</div>
          {totalWert === 0 ? (
            <div className="empty">Noch keine Daten · Assets hinzufügen</div>
          ) : (
            [
              { label: "Immobilien", wert: immoWert, farbe: "#0d9488" },
              { label: "ETF & Aktien", wert: etfWert, farbe: "#2563eb" },
              { label: "Krypto", wert: kryptoWert, farbe: "#f59e0b" },
              { label: "Liquidität", wert: liquidWert, farbe: "#16a34a" },
            ].filter(i => i.wert > 0).map(item => (
              <div key={item.label} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ fontSize: 13, fontWeight: 500 }}>{item.label}</span>
                  <span style={{ fontSize: 13, color: "var(--text2)" }}>{fmtEur(item.wert)} · {((item.wert / totalWert) * 100).toFixed(0)} %</span>
                </div>
                <div className="alloc-bar"><div className="alloc-fill" style={{ width: `${(item.wert / totalWert) * 100}%`, background: item.farbe }} /></div>
              </div>
            ))
          )}
        </div>

        <div className="card">
          <div className="card-title"><span className="ct-icon">⚡</span>Schnellzugriff</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              { label: "Immobilie hinzufügen", sub: "Objekt tracken & Rendite berechnen", icon: "🏘️", page: "immo-portfolio" },
              { label: "ETF/Aktie hinzufügen", sub: "Depot & Allokation", icon: "📈", page: "etf" },
              { label: "Krypto hinzufügen", sub: "BTC, ETH & mehr", icon: "₿", page: "krypto" },
              { label: "Konto hinzufügen", sub: "Tagesgeld, Festgeld, Girokonto", icon: "💰", page: "liquiditaet" },
              { label: "KI-Assistent fragen", sub: "KI-gestützte Analyse", icon: "🤖", page: "ki-assistent" },
            ].map(item => (
              <button key={item.page} onClick={() => setPage(item.page)}
                style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8, cursor: "pointer", transition: "all 0.15s", textAlign: "left" }}
                onMouseEnter={e => { e.currentTarget.style.background = "var(--teal-light)"; e.currentTarget.style.borderColor = "var(--teal-mid)"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "var(--surface2)"; e.currentTarget.style.borderColor = "var(--border)"; }}>
                <span style={{ fontSize: 18 }}>{item.icon}</span>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{item.label}</div>
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>{item.sub}</div>
                </div>
                <span style={{ marginLeft: "auto", color: "var(--text3)", fontSize: 14 }}>›</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {immobilien.length > 0 && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-title"><span className="ct-icon">🏘️</span>Immobilien-Portfolio</div>
          {immobilien.map(p => (
            <div className="row-item" key={p.id}>
              <div>
                <div className="row-label">{p.name}</div>
                <div className="row-sub">{p.adresse}</div>
              </div>
              <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                <div className="row-right"><div className="row-val">{fmtEur(p.miete)}/Mo</div><div className="row-sub">Miete</div></div>
                <div className="row-right"><div className="row-val">{fmtEur(p.aktueller_wert)}</div><div className="row-sub">Wert</div></div>
                <span className={`badge ${p.status === "Vermietet" ? "badge-green" : "badge-amber"}`}>{p.status}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {totalWert > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-title" style={{ justifyContent: "space-between" }}>
            <span><span className="ct-icon">🤖</span>KI Monats-Report</span>
            {!isPro && <span style={{ fontSize: 11, background: "var(--teal-light)", color: "var(--teal)", padding: "3px 10px", borderRadius: 20, fontWeight: 700 }}>PRO</span>}
          </div>
          {isPro ? (
            <>
              <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 14 }}>Lass die KI dein Portfolio analysieren und bekomme personalisierte Empfehlungen für diesen Monat.</div>
              <button className="btn" style={{ marginBottom: 14 }} onClick={generateReport} disabled={kiLoading}>
                {kiLoading ? <span className="dots">KI analysiert Portfolio</span> : "📊 Monats-Report generieren"}
              </button>
              {kiReport && (
                <div className="ai-box">
                  <div className="ai-label">🤖 KI-Monatsüberblick · {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</div>
                  {kiReport}
                </div>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "8px 0" }}>
              <div style={{ fontSize: 13, color: "var(--text2)", flex: 1 }}>Monatliche KI-Analyse deines gesamten Portfolios mit konkreten Handlungsempfehlungen – nur in PRO.</div>
              <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ background: "var(--teal)", color: "white", padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none", whiteSpace: "nowrap" }}>Jetzt upgraden →</a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── IMMO KALKULATOR ───────────────────────────────────────────────────────────
function ImmoKalkulator({ isPro }) {
  const [form, setForm] = useState({
    kaufpreis: "300000", miete: "1000", nk: "10", zinssatz: "3.8",
    eigenkapital: "20", tilgung: "2", instandhaltung: "1", verwaltung: "5",
    leerstand: "4", afa: "2"
  });
  const [result, setResult] = useState(null);
  const [aiText, setAiText] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  function calculate() {
    const kp = parseFloat(form.kaufpreis) || 0;
    const m  = parseFloat(form.miete) || 0;
    const nkP = parseFloat(form.nk) || 10;
    const zins = parseFloat(form.zinssatz) || 3.8;
    const tilg = parseFloat(form.tilgung) || 2;
    const ek = parseFloat(form.eigenkapital) || 20;
    const instand = parseFloat(form.instandhaltung) || 1; // €/m² pro Monat (als % vom KP p.a.)
    const verwP = parseFloat(form.verwaltung) || 5;       // % der Jahresnettomiete
    const leerP = parseFloat(form.leerstand) || 4;        // % Leerstand p.a.
    const afaP  = parseFloat(form.afa) || 2;              // % AfA p.a.

    const nebenkosten = kp * (nkP / 100);
    const gesamtkosten = kp + nebenkosten;
    const fremdkapital = gesamtkosten * ((100 - ek) / 100);
    const eigenkapitalBetrag = gesamtkosten * (ek / 100);

    const jahresmiete = m * 12;
    const leerstandKosten = jahresmiete * (leerP / 100);
    const verwaltungskosten = (jahresmiete - leerstandKosten) * (verwP / 100);
    const instandhaltungskosten = kp * (instand / 100); // instand als % des KP
    const jahresreinertrag = jahresmiete - leerstandKosten - verwaltungskosten - instandhaltungskosten;

    const zinslast = fremdkapital * (zins / 100);
    const tilgungsjahr = fremdkapital * (tilg / 100);
    const annuitat = zinslast + tilgungsjahr;
    const cashflow = jahresreinertrag - zinslast;
    const cashflowNachTilgung = jahresreinertrag - annuitat;

    const bruttorendite = kp > 0 ? (jahresmiete / kp) * 100 : 0;
    const nettorendite  = gesamtkosten > 0 ? (jahresreinertrag / gesamtkosten) * 100 : 0;
    const ekRendite     = eigenkapitalBetrag > 0 ? (cashflow / eigenkapitalBetrag) * 100 : 0;
    const faktor        = m > 0 ? kp / jahresmiete : 0;
    const afaErsparnis  = kp * 0.7 * (afaP / 100); // 70% des KP AfA-Basis

    setResult({ gesamtkosten, fremdkapital, eigenkapitalBetrag, jahresmiete, jahresreinertrag, zinslast, tilgungsjahr, annuitat, cashflow, cashflowNachTilgung, bruttorendite, nettorendite, ekRendite, faktor, leerstandKosten, verwaltungskosten, instandhaltungskosten, afaErsparnis });
    setAiText("");
  }

  async function getAI() {
    if (!result) return;
    setLoading(true); setAiText("");
    const text = await askAI(`Du bist erfahrener Immobilieninvestor. Analysiere dieses Investment detailliert:
Kaufpreis: ${fmtEur(parseFloat(form.kaufpreis))}, Nebenkosten: ${form.nk}%, Gesamtkosten: ${fmtEur(result.gesamtkosten)}
Eigenkapital: ${form.eigenkapital}% (${fmtEur(result.eigenkapitalBetrag)}), Fremdkapital: ${fmtEur(result.fremdkapital)}
Zinssatz: ${form.zinssatz}%, Tilgung: ${form.tilgung}%
Kaltmiete: ${fmtEur(parseFloat(form.miete))}/Mo, Jahresmiete: ${fmtEur(result.jahresmiete)}
Jahresreinertrag (nach Kosten): ${fmtEur(result.jahresreinertrag)}, Zinslast/Jahr: ${fmtEur(result.zinslast)}
Cashflow vor Tilgung: ${fmtEur(result.cashflow/12)}/Mo, nach Tilgung: ${fmtEur(result.cashflowNachTilgung/12)}/Mo
Bruttorendite: ${pct(result.bruttorendite)}, Nettorendite: ${pct(result.nettorendite)}, EK-Rendite: ${pct(result.ekRendite)}, Kaufpreisfaktor: ${result.faktor.toFixed(1)}x
AfA-Steuerersparnis: ca. ${fmtEur(result.afaErsparnis)}/Jahr

Gib eine klare Einschätzung (4-5 Sätze): 1) Ist das ein gutes Investment? 2) Was sind die Hauptrisiken? 3) Was sollte verhandelt/optimiert werden?`);
    setAiText(text); setLoading(false);
  }

  const colorOf = (val, t1, t2) => val >= t1 ? "c-green" : val >= t2 ? "c-amber" : "c-red";

  return (
    <div>
      <div className="g2" style={{ marginBottom: 16 }}>
        {/* Eingaben */}
        <div className="card">
          <div className="card-title"><span className="ct-icon">🏗️</span>Kaufdaten</div>
          <div className="input-row">
            <div className="field"><label className="label">Kaufpreis (€)</label><input className="input" type="number" value={form.kaufpreis} onChange={set("kaufpreis")} /></div>
            <div className="field"><label className="label">Kaltmiete/Mo (€)</label><input className="input" type="number" value={form.miete} onChange={set("miete")} /></div>
          </div>
          <div className="input-row">
            <div className="field"><label className="label">Kaufnebenkosten (%)</label><input className="input" type="number" value={form.nk} onChange={set("nk")} /></div>
            <div className="field"><label className="label">Eigenkapital (%)</label><input className="input" type="number" value={form.eigenkapital} onChange={set("eigenkapital")} /></div>
          </div>
          <div className="input-row">
            <div className="field"><label className="label">Zinssatz (%)</label><input className="input" type="number" step="0.1" value={form.zinssatz} onChange={set("zinssatz")} /></div>
            <div className="field"><label className="label">Tilgung (%)</label><input className="input" type="number" step="0.5" value={form.tilgung} onChange={set("tilgung")} /></div>
          </div>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", margin: "14px 0 8px" }}>Bewirtschaftungskosten</div>
          <div className="input-row">
            <div className="field"><label className="label">Instandhaltung (% KP/Jahr)</label><input className="input" type="number" step="0.1" value={form.instandhaltung} onChange={set("instandhaltung")} /></div>
            <div className="field"><label className="label">Verwaltung (% Miete/Jahr)</label><input className="input" type="number" step="0.5" value={form.verwaltung} onChange={set("verwaltung")} /></div>
          </div>
          <div className="input-row">
            <div className="field"><label className="label">Leerstand (% Miete/Jahr)</label><input className="input" type="number" step="0.5" value={form.leerstand} onChange={set("leerstand")} /></div>
            <div className="field"><label className="label">AfA-Satz (%)</label><input className="input" type="number" step="0.5" value={form.afa} onChange={set("afa")} /></div>
          </div>
          <button className="btn" onClick={calculate}>Rendite berechnen →</button>
        </div>

        {/* Ergebnis */}
        <div className="card">
          <div className="card-title"><span className="ct-icon">📊</span>Ergebnis</div>
          {result ? (
            <>
              {/* Hauptkennzahlen */}
              <div className="stat-grid" style={{ marginBottom: 12 }}>
                <div className="stat"><div className="stat-label">Bruttorendite</div><div className={`stat-value ${colorOf(result.bruttorendite, 5, 3.5)}`}>{pct(result.bruttorendite)}</div></div>
                <div className="stat"><div className="stat-label">Nettorendite</div><div className={`stat-value ${colorOf(result.nettorendite, 3.5, 2)}`}>{pct(result.nettorendite)}</div></div>
                <div className="stat"><div className="stat-label">EK-Rendite</div><div className={`stat-value ${colorOf(result.ekRendite, 8, 4)}`}>{pct(result.ekRendite)}</div></div>
              </div>
              <div className="stat-grid" style={{ marginBottom: 12 }}>
                <div className="stat"><div className="stat-label">Cashflow/Mo</div><div className={`stat-value ${result.cashflow >= 0 ? "c-green" : "c-red"}`}>{fmtEur(result.cashflow / 12)}</div><div className="stat-sub">vor Tilgung</div></div>
                <div className="stat"><div className="stat-label">Cashflow/Mo</div><div className={`stat-value ${result.cashflowNachTilgung >= 0 ? "c-teal" : "c-red"}`}>{fmtEur(result.cashflowNachTilgung / 12)}</div><div className="stat-sub">nach Tilgung</div></div>
                <div className="stat"><div className="stat-label">Kaufpreisfaktor</div><div className={`stat-value ${result.faktor < 20 ? "c-green" : result.faktor < 25 ? "c-amber" : "c-red"}`}>{result.faktor.toFixed(1)}x</div></div>
              </div>
              <hr className="divider" />
              {/* Kostenaufschlüsselung */}
              <div style={{ fontSize: 12, marginBottom: 8, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em" }}>Jahreskosten-Aufschlüsselung</div>
              {[
                { label: "Kaltmiete/Jahr", val: result.jahresmiete, color: "var(--green)" },
                { label: "− Leerstand", val: -result.leerstandKosten, color: "var(--red)" },
                { label: "− Verwaltung", val: -result.verwaltungskosten, color: "var(--red)" },
                { label: "− Instandhaltung", val: -result.instandhaltungskosten, color: "var(--red)" },
                { label: "= Jahresreinertrag", val: result.jahresreinertrag, color: "var(--teal)", bold: true },
                { label: "− Zinslast", val: -result.zinslast, color: "var(--red)" },
                { label: "= Cashflow (vor Tilgung)", val: result.cashflow, color: result.cashflow >= 0 ? "var(--green)" : "var(--red)", bold: true },
              ].map(row => (
                <div key={row.label} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid var(--border)", fontSize: 13, fontWeight: row.bold ? 700 : 400 }}>
                  <span style={{ color: "var(--text2)" }}>{row.label}</span>
                  <span style={{ color: row.color }}>{row.val >= 0 ? "+" : ""}{fmtEur(Math.abs(row.val))}</span>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", fontSize: 13, color: "var(--teal)" }}>
                <span>AfA-Steuerersparnis (ca.)</span>
                <span>+{fmtEur(result.afaErsparnis)}</span>
              </div>
              <hr className="divider" />
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 12, color: "var(--text3)" }}>
                <span>Gesamtkosten: {fmtEur(result.gesamtkosten)}</span>
                <span>·</span>
                <span>EK: {fmtEur(result.eigenkapitalBetrag)}</span>
                <span>·</span>
                <span>FK: {fmtEur(result.fremdkapital)}</span>
                <span>·</span>
                <span>Annuität: {fmtEur(result.annuitat / 12)}/Mo</span>
              </div>
              {isPro
                ? <button className="btn btn-ghost btn-sm" style={{ marginTop: 14, width: "100%" }} onClick={getAI} disabled={loading}>
                    {loading ? <span className="dots">KI analysiert</span> : "🤖 KI-Einschätzung erhalten"}
                  </button>
                : <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank"
                    style={{ display: "block", marginTop: 14, textAlign: "center", fontSize: 12, fontWeight: 700, color: "var(--teal)", textDecoration: "none", background: "var(--teal-light)", padding: "10px", borderRadius: 8 }}>
                    🔒 KI-Einschätzung – nur PRO
                  </a>
              }
              {aiText && <div className="ai-box"><div className="ai-label">🤖 KI-Analyse</div>{aiText}</div>}
            </>
          ) : (
            <div className="empty">Daten eingeben und Rendite berechnen</div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── IMMO BEWERTUNG ────────────────────────────────────────────────────────────
function ImmoBewertung() {
  const [form, setForm] = useState({ adresse: "", typ: "Eigentumswohnung", flaeche: "", zimmer: "", baujahr: "", zustand: "gut", garage: "Nein", etage: "", aufzug: "Nein", keller: "Nein", beschreibung: "" });
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  async function bewerten() {
    setLoading(true); setResult("");
    const details = [
      `Adresse/Lage: ${form.adresse || "nicht angegeben"}`,
      `Typ: ${form.typ}`,
      form.flaeche ? `Wohnfläche: ${form.flaeche} m²` : "",
      form.zimmer ? `Zimmer: ${form.zimmer}` : "",
      form.baujahr ? `Baujahr: ${form.baujahr}` : "",
      `Zustand: ${form.zustand}`,
      form.garage !== "Nein" ? `Garage/Stellplatz: ${form.garage}` : "",
      form.etage ? `Etage: ${form.etage}` : "",
      form.aufzug !== "Nein" ? "Aufzug: Ja" : "",
      form.keller !== "Nein" ? "Keller: Ja" : "",
      form.beschreibung ? `Weitere Details: ${form.beschreibung}` : "",
    ].filter(Boolean).join(", ");
    const text = await askAI(`Du bist ein hilfreicher KI-Assistent für Immobilienanalysen in Deutschland. Erstelle eine informative Einschätzung zur folgenden Immobilie: ${details}. Strukturiere deine Antwort mit: 1) Lagebewertung (Mikro- und Makrolage, Infrastruktur) 2) Geschätzte Preisspanne in Euro (grobe Orientierung auf Basis öffentlicher Marktdaten) 3) Mögliche Kaltmiete pro Monat 4) Grobe Bruttorendite-Schätzung 5) Potenziale und Risiken. Weise am Ende klar darauf hin, dass dies eine KI-Einschätzung und kein offizielles Gutachten ist.`, "Du bist ein hilfreicher KI-Assistent für Immobilienanalysen. Antworte auf Deutsch, strukturiert, ohne Markdown-Sternchen. Verwende Ziffern für die Punkte. Weise am Ende auf den informatorischen Charakter hin.");
    setResult(text); setLoading(false);
  }

  return (
    <div className="g2">
      <div className="card">
        <div className="card-title"><span className="ct-icon">🔍</span>Immobilie eingeben</div>
        <div className="field"><label className="label">Adresse / Lage</label><input className="input" placeholder="z.B. Schillerstr. 12, Leipzig" value={form.adresse} onChange={set("adresse")} /></div>
        <div className="input-row">
          <div className="field"><label className="label">Immobilientyp</label>
            <select className="input" value={form.typ} onChange={set("typ")}>
              <option>Eigentumswohnung</option><option>Einfamilienhaus</option><option>Mehrfamilienhaus</option><option>Gewerbeimmobilie</option><option>Reihenhaus</option>
            </select>
          </div>
          <div className="field"><label className="label">Zustand</label>
            <select className="input" value={form.zustand} onChange={set("zustand")}>
              <option value="sehr gut">Sehr gut / Neubau</option><option value="gut">Gut / Gepflegt</option><option value="mittel">Mittel / Renovierungsbedarf</option><option value="schlecht">Schlecht / Sanierungsbedarf</option>
            </select>
          </div>
        </div>
        <div className="input-row">
          <div className="field"><label className="label">Wohnfläche (m²)</label><input className="input" type="number" placeholder="85" value={form.flaeche} onChange={set("flaeche")} /></div>
          <div className="field"><label className="label">Zimmer</label><input className="input" type="number" step="0.5" placeholder="3" value={form.zimmer} onChange={set("zimmer")} /></div>
          <div className="field"><label className="label">Baujahr</label><input className="input" type="number" placeholder="1995" value={form.baujahr} onChange={set("baujahr")} /></div>
        </div>
        <div className="input-row">
          <div className="field"><label className="label">Etage</label><input className="input" placeholder="z.B. 2. OG, EG" value={form.etage} onChange={set("etage")} /></div>
          <div className="field"><label className="label">Garage/Stellplatz</label>
            <select className="input" value={form.garage} onChange={set("garage")}>
              <option>Nein</option><option>Garage</option><option>Tiefgarage</option><option>Stellplatz</option>
            </select>
          </div>
        </div>
        <div className="input-row">
          <div className="field"><label className="label">Aufzug</label>
            <select className="input" value={form.aufzug} onChange={set("aufzug")}><option>Nein</option><option>Ja</option></select>
          </div>
          <div className="field"><label className="label">Keller</label>
            <select className="input" value={form.keller} onChange={set("keller")}><option>Nein</option><option>Ja</option></select>
          </div>
        </div>
        <div className="field"><label className="label">Weitere Details</label><textarea className="input" placeholder="z.B. Balkon, Fußbodenheizung, Kernsanierung 2020, ruhige Lage..." value={form.beschreibung} onChange={set("beschreibung")} /></div>
        <button className="btn" onClick={bewerten} disabled={loading || !form.adresse}>{loading ? <span className="dots">KI analysiert</span> : "🤖 KI-Analyse erstellen"}</button>
      </div>
      <div className="card">
        <div className="card-title"><span className="ct-icon">✨</span>Bewertungsergebnis</div>
        {loading && <div style={{ padding: "32px 0", textAlign: "center" }}><span className="dots" style={{ color: "var(--text3)", fontStyle: "italic" }}>KI analysiert Lage, Marktdaten und Vergleichsobjekte</span></div>}
        {result && <div className="ai-box"><div className="ai-label">🤖 KI-Analyse (kein offizielles Gutachten)</div><div style={{ whiteSpace: "pre-line" }}>{result}</div></div>}
        {!result && !loading && <div className="empty">Adresse & Details eingeben, dann KI-Gutachten erstellen</div>}
      </div>
    </div>
  );
}

// ── IMMO PORTFOLIO ────────────────────────────────────────────────────────────
function ImmoPortfolio({ user, isPro }) {
  const { data: immobilien, loading, add, remove, update, writeError } = useUserData("immobilien", user?.id);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId]     = useState(null);
  const [editWert, setEditWert] = useState("");
  const [aiWert, setAiWert]               = useState({});
  const [aiWertLoading, setAiWertLoading] = useState({});
  const [aiText, setAiText]     = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [form, setForm] = useState({ name: "", adresse: "", kaufpreis: "", aktueller_wert: "", miete: "", warmmiete: "", hausgeld: "", nebenkosten: "", bankrate: "", status: "Vermietet", typ: "Eigentumswohnung", wohnflaeche: "", baujahr: "", zustand: "gut", garage: "Nein", restschuld: "" });
  const MAX_FREE = 1;
  const canAdd = isPro || immobilien.length < MAX_FREE;
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  // Cashflow = Kaltmiete - Hausgeld - Nebenkosten
  const calcCashflow = p => (p.miete || 0) - (p.hausgeld || 0) - (p.nebenkosten || 0);
  const totalWert       = immobilien.reduce((s, p) => s + (p.aktueller_wert || 0), 0);
  const totalRestschuld = immobilien.reduce((s, p) => s + (p.restschuld || 0), 0);
  const totalNettoWert  = totalWert - totalRestschuld;
  const totalKauf       = immobilien.reduce((s, p) => s + (p.kaufpreis || 0), 0);
  const totalMiete      = immobilien.reduce((s, p) => s + (p.miete || 0), 0);
  const totalCashflow   = immobilien.reduce((s, p) => s + calcCashflow(p), 0);

  async function handleAdd(e) {
    e.preventDefault();
    const result = await add({
      ...form,
      kaufpreis:      parseFloat(form.kaufpreis)      || 0,
      aktueller_wert: parseFloat(form.aktueller_wert) || 0,
      miete:          parseFloat(form.miete)           || 0,
      warmmiete:      parseFloat(form.warmmiete)       || 0,
      hausgeld:       parseFloat(form.hausgeld)        || 0,
      nebenkosten:    parseFloat(form.nebenkosten)     || 0,
      bankrate:       parseFloat(form.bankrate)        || 0,
      wohnflaeche:    parseFloat(form.wohnflaeche)     || 0,
      baujahr:        parseInt(form.baujahr)           || 0,
      restschuld:     parseFloat(form.restschuld)      || 0,
    });
    if (result) {
      setForm({ name: "", adresse: "", kaufpreis: "", aktueller_wert: "", miete: "", warmmiete: "", hausgeld: "", nebenkosten: "", bankrate: "", status: "Vermietet", typ: "Eigentumswohnung", wohnflaeche: "", baujahr: "", zustand: "gut", garage: "Nein", restschuld: "" });
      setShowForm(false);
    }
    // Kein setShowForm(false) bei Fehler → Formular bleibt offen, Fehler wird angezeigt
  }

  async function handleUpdateWert(p) {
    const newWert = parseFloat(editWert);
    if (!newWert || isNaN(newWert)) return;
    await update(p.id, { aktueller_wert: newWert });
    setEditId(null); setEditWert("");
  }

  async function getAIWert(p) {
    setAiWertLoading(prev => ({ ...prev, [p.id]: true }));
    const details = [
      `Name: "${p.name}"`, `Adresse: "${p.adresse}"`, `Typ: "${p.typ}"`,
      p.wohnflaeche ? `Wohnfläche: ${p.wohnflaeche} m²` : "",
      p.baujahr ? `Baujahr: ${p.baujahr}` : "",
      p.zustand ? `Zustand: ${p.zustand}` : "",
      p.garage !== "Nein" ? `Garage: ${p.garage}` : "",
      `Kaufpreis: ${fmtEur(p.kaufpreis)}`,
      p.miete ? `Kaltmiete: ${fmtEur(p.miete)}/Mo` : "",
    ].filter(Boolean).join(", ");
    const text = await askAI(`Du bist Immobiliengutachter. Schätze den aktuellen Marktwert: ${details}. Gib NUR eine Zahl zurück (Marktwert in Euro, z.B. 320000). Kein Text, nur die Zahl.`);
    const wert = parseFloat(text.replace(/[^0-9]/g, ""));
    if (!isNaN(wert) && wert > 0) setAiWert(prev => ({ ...prev, [p.id]: wert }));
    setAiWertLoading(prev => ({ ...prev, [p.id]: false }));
  }

  async function analyze() {
    setAiLoading(true); setAiText("");
    const desc = immobilien.map(p => `${p.name}: Kaufpreis ${fmtEur(p.kaufpreis)}, Miete ${fmtEur(p.miete)}/Mo, Status: ${p.status}`).join("\n");
    const text = await askAI(`Analysiere dieses Immobilienportfolio:\n${desc}\nGesamtwert: ${fmtEur(totalWert)}, Mieteinnahmen: ${fmtEur(totalMiete)}/Mo. Empfehlungen in 4-5 Sätzen.`);
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div className="g4" style={{ marginBottom: 16 }}>
        <div className="metric"><div className="metric-label">Bruttowert</div><div className="metric-value c-teal">{fmtEur(totalWert)}</div><div className="metric-sub">{immobilien.length} Objekte</div></div>
        <div className="metric"><div className="metric-label">Nettovermögen</div><div className="metric-value c-green">{fmtEur(totalNettoWert)}</div><div className="metric-sub">{totalRestschuld > 0 ? `− ${fmtEur(totalRestschuld)} Restschuld` : "Kein Darlehen"}</div></div>
        <div className="metric"><div className="metric-label">Kaltmiete/Mo</div><div className="metric-value c-amber">{fmtEur(totalMiete)}</div><div className="metric-sub">{totalKauf > 0 ? `Ø Rendite ${((totalMiete*12/totalKauf)*100).toFixed(1)} %` : ""}</div></div>
        <div className="metric"><div className="metric-label">Cashflow/Mo</div><div className={`metric-value ${totalCashflow >= 0 ? "c-green" : "c-red"}`}>{fmtEur(totalCashflow)}</div><div className="metric-sub">nach Hausgeld & Kosten</div></div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title" style={{ justifyContent: "space-between" }}>
          <span><span className="ct-icon">🏘️</span>Alle Objekte</span>
          {canAdd
            ? <button className="btn btn-sm" onClick={() => setShowForm(!showForm)}>+ Objekt hinzufügen</button>
            : <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ fontSize: 12, fontWeight: 700, color: "var(--teal)", textDecoration: "none", background: "var(--teal-light)", padding: "6px 12px", borderRadius: 7 }}>🔒 PRO – mehr Objekte</a>}
        </div>

        {showForm && (
          <form onSubmit={handleAdd} style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 16, border: "1px solid var(--border)" }}>
            {writeError && (
              <div style={{ background: "var(--red-light)", border: "1px solid var(--red)", borderRadius: 8, padding: "10px 14px", marginBottom: 12, fontSize: 13, color: "var(--red)", fontWeight: 600 }}>
                ⚠️ {writeError}
              </div>
            )}
            <div className="input-row">
              <div className="field"><label className="label">Name</label><input className="input" placeholder="z.B. Wohnung München" value={form.name} onChange={set("name")} required /></div>
              <div className="field"><label className="label">Typ</label>
                <select className="input" value={form.typ} onChange={set("typ")}>
                  <option>Eigentumswohnung</option><option>Einfamilienhaus</option><option>Mehrfamilienhaus</option><option>Gewerbeimmobilie</option>
                </select>
              </div>
            </div>
            <div className="field"><label className="label">Adresse</label><input className="input" placeholder="Straße, PLZ Stadt" value={form.adresse} onChange={set("adresse")} /></div>
            <div className="input-row">
              <div className="field"><label className="label">Wohnfläche (m²)</label><input className="input" type="number" placeholder="85" value={form.wohnflaeche} onChange={set("wohnflaeche")} /></div>
              <div className="field"><label className="label">Baujahr</label><input className="input" type="number" placeholder="1995" value={form.baujahr} onChange={set("baujahr")} /></div>
              <div className="field"><label className="label">Zustand</label>
                <select className="input" value={form.zustand} onChange={set("zustand")}>
                  <option value="sehr gut">Sehr gut / Neubau</option><option value="gut">Gut / Gepflegt</option><option value="mittel">Mittel / Renovierungsbedarf</option><option value="schlecht">Schlecht / Sanierungsbedarf</option>
                </select>
              </div>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Garage / Stellplatz</label>
                <select className="input" value={form.garage} onChange={set("garage")}>
                  <option>Nein</option><option>Garage</option><option>Tiefgarage</option><option>Stellplatz</option>
                </select>
              </div>
              <div className="field"><label className="label">Status</label>
                <select className="input" value={form.status} onChange={set("status")}>
                  <option>Vermietet</option><option>Leerstand</option><option>Teilvermiet.</option><option>Eigennutzung</option>
                </select>
              </div>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Kaufpreis (€)</label><input className="input" type="number" placeholder="300000" value={form.kaufpreis} onChange={set("kaufpreis")} /></div>
              <div className="field"><label className="label">Aktueller Wert (€)</label><input className="input" type="number" placeholder="320000" value={form.aktueller_wert} onChange={set("aktueller_wert")} /></div>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Kaltmiete/Mo (€)</label><input className="input" type="number" placeholder="1000" value={form.miete} onChange={set("miete")} /></div>
              <div className="field"><label className="label">Warmmiete/Mo (€) <span style={{fontWeight:400,textTransform:"none",fontSize:10}}>(optional)</span></label><input className="input" type="number" placeholder="1200" value={form.warmmiete} onChange={set("warmmiete")} /></div>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Hausgeld/Mo (€)</label><input className="input" type="number" placeholder="250" value={form.hausgeld} onChange={set("hausgeld")} /></div>
              <div className="field"><label className="label">Weitere Kosten/Mo (€)</label><input className="input" type="number" placeholder="0" value={form.nebenkosten} onChange={set("nebenkosten")} /></div>
            </div>
            <div style={{ background: "var(--teal-light)", border: "1px solid rgba(13,148,136,0.2)", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "var(--teal)", marginBottom: 12 }}>
              <strong>Cashflow:</strong> {fmtEur((parseFloat(form.miete)||0) - (parseFloat(form.hausgeld)||0) - (parseFloat(form.nebenkosten)||0))}/Mo
              <span style={{ fontSize: 11, color: "var(--text3)", marginLeft: 8 }}>(Kaltmiete − Hausgeld − Kosten)</span>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Restschuld Darlehen (€)</label><input className="input" type="number" placeholder="0" value={form.restschuld} onChange={set("restschuld")} /></div>
              <div className="field"><label className="label">Monatliche Bankrate (€)</label><input className="input" type="number" placeholder="800" value={form.bankrate} onChange={set("bankrate")} /></div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn" type="submit">Speichern</button>
              <button className="btn btn-ghost" type="button" onClick={() => setShowForm(false)}>Abbrechen</button>
            </div>
          </form>
        )}

        {loading ? <div className="empty"><span className="dots">Laden</span></div> :
          immobilien.length === 0 ? <div className="empty">Noch keine Objekte · Klick "+ Objekt hinzufügen"</div> :
          immobilien.map(p => (
            <div key={p.id}>
              <div className="row-item">
                <div>
                  <div className="row-label">{p.name}</div>
                  <div className="row-sub">{p.adresse} · {p.typ}{p.wohnflaeche > 0 ? ` · ${p.wohnflaeche} m²` : ""}{p.baujahr > 0 ? ` · Bj. ${p.baujahr}` : ""}</div>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div className="row-right">
                    <div className="row-val">{fmtEur(p.miete)}/Mo</div>
                    <div className="row-sub">Kaltmiete</div>
                  </div>
                  <div className="row-right">
                    <div className={`row-val ${calcCashflow(p) >= 0 ? "c-green" : "c-red"}`}>{fmtEur(calcCashflow(p))}/Mo</div>
                    <div className="row-sub">Cashflow</div>
                  </div>
                  <div className="row-right">
                    <div className="row-val">{fmtEur(aiWert[p.id] || p.aktueller_wert)}</div>
                    <div className="row-sub">{p.restschuld > 0 ? `Netto: ${fmtEur((aiWert[p.id] || p.aktueller_wert) - p.restschuld)}` : "Bruttowert"}</div>
                  </div>
                  {p.wohnflaeche > 0 && <div className="row-right" style={{ display: "none" }}></div>}
                  <span className={`badge ${p.status === "Vermietet" ? "badge-green" : "badge-amber"}`}>{p.status}</span>
                  <button onClick={() => { setEditId(editId === p.id ? null : p.id); setEditWert(String(p.aktueller_wert || "")); }}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "var(--teal)", fontSize: 14, padding: "4px" }} title="Wert bearbeiten">✏️</button>
                  <button onClick={() => remove(p.id)}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 16, padding: "4px" }} title="Löschen">✕</button>
                </div>
              </div>
              {editId === p.id && (
                <div style={{ padding: "14px 16px", background: "var(--surface2)", borderRadius: 8, margin: "4px 0 8px", border: "1px solid var(--border)" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text2)", marginBottom: 12 }}>Alle Werte bearbeiten</div>
                  <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text3)", marginBottom: 6 }}>Bewertung</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Marktwert (€)</div>
                      <input className="input" type="number" placeholder="z.B. 320000" value={editWert} onChange={e => setEditWert(e.target.value)} />
                    </div>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Restschuld (€)</div>
                      <input className="input" type="number" placeholder="0" defaultValue={p.restschuld || ""} id={`restschuld-${p.id}`} />
                    </div>
                  </div>
                  <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text3)", marginBottom: 6 }}>Einnahmen & Kosten / Monat</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Kaltmiete (€)</div>
                      <input className="input" type="number" placeholder="0" defaultValue={p.miete || ""} id={`miete-${p.id}`} />
                    </div>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Hausgeld (€)</div>
                      <input className="input" type="number" placeholder="0" defaultValue={p.hausgeld || ""} id={`hausgeld-${p.id}`} />
                    </div>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Weitere Kosten (€)</div>
                      <input className="input" type="number" placeholder="0" defaultValue={p.nebenkosten || ""} id={`nebenkosten-${p.id}`} />
                    </div>
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "var(--text3)", marginBottom: 4 }}>Bankrate/Mo (€)</div>
                      <input className="input" type="number" placeholder="0" defaultValue={p.bankrate || ""} id={`bankrate-${p.id}`} />
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <button className="btn btn-sm" onClick={() => {
                      const rs = parseFloat(document.getElementById(`restschuld-${p.id}`)?.value) || 0;
                      const hg = parseFloat(document.getElementById(`hausgeld-${p.id}`)?.value) || 0;
                      const nk = parseFloat(document.getElementById(`nebenkosten-${p.id}`)?.value) || 0;
                      const br = parseFloat(document.getElementById(`bankrate-${p.id}`)?.value) || 0;
                      const mi = parseFloat(document.getElementById(`miete-${p.id}`)?.value) || 0;
                      update(p.id, { restschuld: rs, hausgeld: hg, nebenkosten: nk, bankrate: br, miete: mi });
                      handleUpdateWert(p);
                    }}>Speichern</button>
                    {isPro
                      ? <button className="btn btn-sm btn-ghost" onClick={() => getAIWert(p)} disabled={aiWertLoading[p.id]}>
                          {aiWertLoading[p.id] ? <span className="dots">KI schätzt</span> : "🤖 KI-Schätzung"}
                        </button>
                      : <span style={{ fontSize: 11, color: "var(--teal)", fontWeight: 600, padding: "4px 8px", background: "var(--teal-light)", borderRadius: 6 }}>🔒 PRO</span>
                    }
                    {aiWert[p.id] && (
                      <span style={{ fontSize: 13, color: "var(--teal)", fontWeight: 600 }}>
                        KI-Schätzung: {fmtEur(aiWert[p.id])}
                        <button onClick={() => setEditWert(String(aiWert[p.id]))} style={{ background: "none", border: "none", color: "var(--teal)", cursor: "pointer", fontSize: 12, marginLeft: 6 }}>↑ übernehmen</button>
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))
        }
        {immobilien.length > 0 && (
          <>
            {isPro
              ? <button className="btn" style={{ maxWidth: 280, marginTop: 14 }} onClick={analyze} disabled={aiLoading}>{aiLoading ? <span className="dots">KI analysiert</span> : "🤖 Portfolio analysieren"}</button>
              : <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ display: "inline-block", marginTop: 14, fontSize: 12, fontWeight: 700, color: "var(--teal)", textDecoration: "none", background: "var(--teal-light)", padding: "8px 14px", borderRadius: 7 }}>🔒 PRO – KI-Portfolio-Analyse freischalten</a>
            }
            {aiText && <div className="ai-box" style={{ marginTop: 14 }}><div className="ai-label">🤖 Portfolio-Analyse</div>{aiText}</div>}
          </>
        )}
      </div>
    </div>
  );
}

// ── IMMO VERWALTUNG ───────────────────────────────────────────────────────────
function ImmoVerwaltung({ user }) {
  const { data: immobilien } = useUserData("immobilien", user?.id);
  const [sel, setSel]   = useState(null);
  const [aiText, setAiText]   = useState("");
  const [loading, setLoading] = useState(false);
  const [issue, setIssue]     = useState("");
  const [aufgaben, setAufgaben] = useState([
    { id: 1, titel: "Nebenkostenabrechnung erstellen", faellig: "31.05.2026", prio: "hoch",   erledigt: false },
    { id: 2, titel: "Heizungsinspektion beauftragen",  faellig: "15.06.2026", prio: "mittel", erledigt: false },
    { id: 3, titel: "Mieterhöhung prüfen (Mietspiegel)", faellig: "01.07.2026", prio: "niedrig", erledigt: false },
  ]);
  const [neueAufgabe, setNeueAufgabe]       = useState({ titel: "", faellig: "", prio: "mittel" });
  const [showAufgabeForm, setShowAufgabeForm] = useState(false);

  function toggleErledigt(id) { setAufgaben(prev => prev.map(a => a.id === id ? { ...a, erledigt: !a.erledigt } : a)); }
  function deleteAufgabe(id)  { setAufgaben(prev => prev.filter(a => a.id !== id)); }
  function addAufgabe(e) {
    e.preventDefault();
    if (!neueAufgabe.titel) return;
    setAufgaben(prev => [...prev, { ...neueAufgabe, id: Date.now(), erledigt: false }]);
    setNeueAufgabe({ titel: "", faellig: "", prio: "mittel" });
    setShowAufgabeForm(false);
  }

  async function handle() {
    if (!issue.trim()) return;
    setLoading(true); setAiText("");
    const objekt = sel ? immobilien.find(p => p.id === sel) : immobilien[0];
    const text = await askAI(`Immobilienverwalter-Assistent. Objekt: "${objekt?.name || "unbekannt"}". Problem: "${issue}". Konkrete Handlungsempfehlungen: Was sofort tun? Rechtliche Aspekte? Wie mit Mieter kommunizieren?`);
    setAiText(text); setLoading(false);
  }

  return (
    <div className="g2">
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div className="card">
          <div className="card-title" style={{ justifyContent: "space-between" }}>
            <span><span className="ct-icon">📋</span>Aufgaben</span>
            <button className="btn btn-sm btn-ghost" onClick={() => setShowAufgabeForm(!showAufgabeForm)}>+ Aufgabe</button>
          </div>
          {showAufgabeForm && (
            <form onSubmit={addAufgabe} style={{ background: "var(--surface2)", borderRadius: 8, padding: 12, marginBottom: 12, border: "1px solid var(--border)" }}>
              <div className="field"><label className="label">Aufgabe</label><input className="input" placeholder="Beschreibung..." value={neueAufgabe.titel} onChange={e => setNeueAufgabe(f => ({ ...f, titel: e.target.value }))} required /></div>
              <div className="input-row">
                <div className="field"><label className="label">Fällig</label><input className="input" type="date" value={neueAufgabe.faellig} onChange={e => setNeueAufgabe(f => ({ ...f, faellig: e.target.value }))} /></div>
                <div className="field"><label className="label">Priorität</label>
                  <select className="input" value={neueAufgabe.prio} onChange={e => setNeueAufgabe(f => ({ ...f, prio: e.target.value }))}>
                    <option value="hoch">Hoch</option><option value="mittel">Mittel</option><option value="niedrig">Niedrig</option>
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="btn btn-sm" type="submit">Hinzufügen</button>
                <button className="btn btn-sm btn-ghost" type="button" onClick={() => setShowAufgabeForm(false)}>Abbrechen</button>
              </div>
            </form>
          )}
          {aufgaben.length === 0
            ? <div className="empty">Keine Aufgaben · Klick "+ Aufgabe"</div>
            : aufgaben.map(a => (
              <div className="row-item" key={a.id} style={{ opacity: a.erledigt ? 0.5 : 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div onClick={() => toggleErledigt(a.id)} style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${a.erledigt ? "var(--green)" : "var(--border2)"}`, background: a.erledigt ? "var(--green)" : "transparent", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    {a.erledigt && <span style={{ color: "white", fontSize: 11, fontWeight: 900 }}>✓</span>}
                  </div>
                  <div>
                    <div className="row-label" style={{ fontSize: 13, textDecoration: a.erledigt ? "line-through" : "none" }}>{a.titel}</div>
                    {a.faellig && <div className="row-sub">Fällig: {a.faellig}</div>}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span className={`badge ${a.prio === "hoch" ? "badge-red" : a.prio === "mittel" ? "badge-amber" : "badge-green"}`}>{a.prio}</span>
                  <button onClick={() => deleteAufgabe(a.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 14 }}>✕</button>
                </div>
              </div>
            ))
          }
        </div>
        <div className="card">
          <div className="card-title"><span className="ct-icon">📊</span>Schnellübersicht</div>
          <div className="stat-grid">
            <div className="stat"><div className="stat-label">Objekte</div><div className="stat-value c-teal">{immobilien.length}</div></div>
            <div className="stat"><div className="stat-label">Aufgaben offen</div><div className="stat-value c-amber">{aufgaben.filter(a => !a.erledigt).length}</div></div>
            <div className="stat"><div className="stat-label">Erledigt</div><div className="stat-value c-green">{aufgaben.filter(a => a.erledigt).length}</div></div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-title"><span className="ct-icon">🤖</span>KI-Verwalter-Assistent</div>
        <div className="field">
          <label className="label">Immobilie</label>
          <select className="input" value={sel || ""} onChange={e => setSel(e.target.value)}>
            <option value="">Immobilie wählen...</option>
            {immobilien.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <div className="field">
          <label className="label">Problem / Frage beschreiben</label>
          <textarea className="input" placeholder="z.B. Mieter zahlt seit 2 Monaten nicht. Was sind meine nächsten Schritte?" value={issue} onChange={e => setIssue(e.target.value)} />
        </div>
        <button className="btn" onClick={handle} disabled={loading || !issue.trim()}>{loading ? <span className="dots">KI analysiert</span> : "Lösung von KI erhalten"}</button>
        {aiText && <div className="ai-box"><div className="ai-label">🤖 Empfehlung</div>{aiText}</div>}
        {!aiText && !loading && (
          <div className="chips">
            {["Mietausfall", "Mietminderung", "Kündigung", "Nebenkostenstreit", "Renovierungspflicht"].map(t => (
              <span key={t} className="chip" onClick={() => setIssue(t)}>{t}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── ETF DASHBOARD ─────────────────────────────────────────────────────────────
function ETFDashboard({ user, isPro }) {
  const { data: positionen, loading, add, remove } = useUserData("etf_positionen", user?.id);
  const { preise: etfPreise, lastUpdate } = useETFLive(positionen);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", ticker: "", symbol: "", anteile: "", kaufkurs: "", typ: "ETF", farbe: "#0d9488" });
  const [aiText, setAiText]     = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [etfSuggestions, setEtfSuggestions] = useState([]);
  const etfDropdownRef = useRef(null);

  // FIX 6: Close dropdown on outside click
  useEffect(() => {
    function handleClick(e) {
      if (etfDropdownRef.current && !etfDropdownRef.current.contains(e.target)) {
        setEtfSuggestions([]);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);
  const MAX_FREE = 3;
  const canAdd = isPro || positionen.length < MAX_FREE;
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const enriched = positionen.map(p => {
    const livePreis = etfPreise[p.ticker] || p.kaufkurs;
    const wert = (p.anteile || 0) * livePreis;
    const rendite = p.kaufkurs ? ((livePreis - p.kaufkurs) / p.kaufkurs) * 100 : 0;
    return { ...p, preis: livePreis, wert, rendite };
  });

  const totalWert = enriched.reduce((s, e) => s + e.wert, 0);

  async function handleAdd(e) {
    e.preventDefault();
    const dbEntry = ETF_DB.find(x => x.ticker === form.ticker);
    const symbol = form.symbol || dbEntry?.symbol || form.ticker;
    const result = await add({ ...form, symbol, anteile: parseFloat(form.anteile) || 0, kaufkurs: parseFloat(form.kaufkurs) || 0 });
    if (result) {
      setForm({ name: "", ticker: "", symbol: "", anteile: "", kaufkurs: "", typ: "ETF", farbe: "#0d9488" });
      setShowForm(false); setEtfSuggestions([]);
    }
  }

  async function analyze() {
    setAiLoading(true); setAiText("");
    const desc = enriched.map(e => `${e.ticker} (${e.name}): ${e.anteile} Anteile, Wert ${fmtEur(e.wert)}, Rendite ${e.rendite.toFixed(1)}%`).join("\n");
    const text = await askAI(`Analysiere dieses ETF/Aktien-Portfolio:\n${desc}\nGesamtwert: ${fmtEur(totalWert)}. Ist die Diversifikation sinnvoll? Rebalancing nötig? (4-5 Sätze)`);
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div className="g3" style={{ marginBottom: 16 }}>
        <div className="metric"><div className="metric-label">Portfolio-Wert</div><div className="metric-value c-blue">{fmtEur(totalWert)}</div><div className="metric-sub">{positionen.length} Positionen</div></div>
        <div className="metric"><div className="metric-label">Datenquelle</div><div className="metric-value" style={{ fontSize: 14, color: lastUpdate ? "var(--green)" : "var(--text3)" }}>{lastUpdate ? "🟢 Live" : positionen.length === 0 ? "–" : <span className="dots">Laden</span>}</div><div className="metric-sub">{lastUpdate ? `Yahoo Finance · ${lastUpdate.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr` : "Yahoo Finance"}</div></div>
        <div className="metric"><div className="metric-label">Positionen</div><div className="metric-value c-text">{positionen.length}</div><div className="metric-sub">ETFs & Aktien</div></div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title" style={{ justifyContent: "space-between" }}>
          <span><span className="ct-icon">📊</span>Positionen</span>
          {canAdd
            ? <button className="btn btn-sm" onClick={() => setShowForm(!showForm)}>+ Position hinzufügen</button>
            : <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ fontSize: 12, fontWeight: 700, color: "var(--teal)", textDecoration: "none", background: "var(--teal-light)", padding: "6px 12px", borderRadius: 7 }}>🔒 PRO – unbegrenzte Positionen</a>}
        </div>

        {showForm && (
          <form onSubmit={handleAdd} style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 16, border: "1px solid var(--border)" }}>
            <div className="field" ref={etfDropdownRef}>
              <label className="label">ETF / Aktie suchen</label>
              <input className="input"
                placeholder="Name oder Ticker eingeben (z.B. Apple, VWCE, SAP)..."
                value={form.name && form.ticker ? `${form.ticker} – ${form.name}` : form.name || ""}
                onChange={e => {
                  const q = e.target.value.toLowerCase();
                  setForm(f => ({ ...f, name: e.target.value, ticker: "" }));
                  if (q.length >= 2) {
                    setEtfSuggestions(ETF_DB.filter(x =>
                      x.ticker.toLowerCase().startsWith(q) || x.name.toLowerCase().includes(q)
                    ).slice(0, 6));
                  } else setEtfSuggestions([]);
                }}
              />
              {etfSuggestions.length > 0 && (
                <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, marginTop: 4, boxShadow: "var(--shadow-md)", overflow: "hidden", position: "relative", zIndex: 20 }}>
                  {etfSuggestions.map(x => (
                    <div key={x.ticker}
                      onClick={() => { setForm(f => ({ ...f, name: x.name, ticker: x.ticker, symbol: x.symbol || x.ticker, typ: x.typ })); setEtfSuggestions([]); }}
                      style={{ padding: "10px 14px", cursor: "pointer", display: "flex", justifyContent: "space-between", fontSize: 13, borderBottom: "1px solid var(--border)" }}
                      onMouseEnter={e => e.currentTarget.style.background = "var(--teal-light)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      <span><strong>{x.ticker}</strong> · {x.name}</span>
                      <span style={{ fontSize: 11, color: "var(--text3)" }}>{x.typ}</span>
                    </div>
                  ))}
                </div>
              )}
              {/* Schnellauswahl */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 8 }}>
                {ETF_DB.slice(0, 10).map(x => (
                  <span key={x.ticker}
                    onClick={() => { setForm(f => ({ ...f, name: x.name, ticker: x.ticker, symbol: x.symbol || x.ticker, typ: x.typ })); setEtfSuggestions([]); }}
                    style={{ background: form.ticker === x.ticker ? "var(--teal)" : "var(--bg)", color: form.ticker === x.ticker ? "white" : "var(--text2)", border: "1px solid var(--border)", borderRadius: 6, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 600 }}>
                    {x.ticker}
                  </span>
                ))}
              </div>
            </div>
            {form.ticker && (
              <div style={{ fontSize: 12, color: "var(--teal)", marginBottom: 12, padding: "6px 10px", background: "var(--teal-light)", borderRadius: 6 }}>
                ✓ Gewählt: <strong>{form.ticker}</strong> – {form.name} ({form.typ})
              </div>
            )}
            <div className="input-row">
              <div className="field"><label className="label">Anteile</label><input className="input" type="number" step="0.001" placeholder="10" value={form.anteile} onChange={set("anteile")} required /></div>
              <div className="field"><label className="label">Kaufkurs (€)</label><input className="input" type="number" step="0.01" placeholder="95.40" value={form.kaufkurs} onChange={set("kaufkurs")} required /></div>
              <div className="field"><label className="label">Typ</label>
                <select className="input" value={form.typ} onChange={set("typ")}><option>ETF</option><option>Aktie</option></select>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn" type="submit" disabled={!form.ticker && !form.name}>Speichern</button>
              <button className="btn btn-ghost" type="button" onClick={() => { setShowForm(false); setForm({ name: "", ticker: "", anteile: "", kaufkurs: "", typ: "ETF", farbe: "#0d9488" }); setEtfSuggestions([]); }}>Abbrechen</button>
            </div>
          </form>
        )}

        {loading ? <div className="empty"><span className="dots">Laden</span></div> :
          enriched.length === 0 ? <div className="empty">Noch keine Positionen · Klick "+ Position hinzufügen"</div> :
          enriched.map(e => (
            <div className="row-item" key={e.id}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 10, height: 10, borderRadius: "50%", background: e.farbe || "#0d9488" }} />
                <div>
                  <div className="row-label">{e.ticker || e.name} · {e.anteile} Anteile</div>
                  <div className="row-sub">{e.name} · Kurs: {fmtEur(e.preis)}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <div className="row-right"><div className="row-val">{fmtEur(e.wert)}</div></div>
                <div className="row-right"><div className="row-val" style={{ color: e.rendite >= 0 ? "var(--green)" : "var(--red)" }}>{e.rendite >= 0 ? "+" : ""}{e.rendite.toFixed(1)} %</div><div className="row-sub">vs Kauf</div></div>
                <button onClick={() => remove(e.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 16 }}>✕</button>
              </div>
            </div>
          ))
        }
        {enriched.length > 0 && (
          <>
            <button className="btn btn-ghost btn-sm" style={{ marginTop: 14, width: "100%" }} onClick={analyze} disabled={aiLoading}>{aiLoading ? <span className="dots">KI analysiert</span> : "🤖 Portfolio analysieren"}</button>
            {aiText && <div className="ai-box"><div className="ai-label">🤖 KI-Analyse</div>{aiText}</div>}
          </>
        )}
      </div>
    </div>
  );
}

// ── KRYPTO DASHBOARD ──────────────────────────────────────────────────────────
function KryptoDashboard({ user, isPro }) {
  const { data: positionen, loading, add, remove } = useUserData("krypto_positionen", user?.id);
  // FIX: Live-Preise aus echten User-Positionen, nicht aus statischer kryptoBase
  const { preise: kryptoPreise, lastUpdate } = useKryptoLiveForPositionen(positionen);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", ticker: "", cg_id: "", menge: "", kaufkurs: "", farbe: "#f59e0b" });
  const [aiText, setAiText]       = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const MAX_FREE = 2;
  const canAdd = isPro || positionen.length < MAX_FREE;
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const enriched = positionen.map(p => {
    const livePreis = p.cg_id && kryptoPreise[p.cg_id] ? kryptoPreise[p.cg_id] : (p.kaufkurs || 0);
    const wert    = (p.menge || 0) * livePreis;
    const rendite = p.kaufkurs ? ((livePreis - p.kaufkurs) / p.kaufkurs) * 100 : 0;
    return { ...p, preis: livePreis, wert, rendite, loading: false };
  });

  const total = enriched.reduce((s, k) => s + k.wert, 0);

  async function handleAdd(e) {
    e.preventDefault();
    // FIX 2: Check if coin already exists → aggregate with weighted avg price
    const existing = positionen.find(p => p.ticker === form.ticker);
    if (existing) {
      const totalMenge = (existing.menge || 0) + (parseFloat(form.menge) || 0);
      const avgKaufkurs = (
        ((existing.menge || 0) * (existing.kaufkurs || 0)) +
        ((parseFloat(form.menge) || 0) * (parseFloat(form.kaufkurs) || 0))
      ) / totalMenge;
      await update(existing.id, { menge: totalMenge, kaufkurs: parseFloat(avgKaufkurs.toFixed(4)) });
    } else {
      await add({ ...form, menge: parseFloat(form.menge) || 0, kaufkurs: parseFloat(form.kaufkurs) || 0 });
    }
    setForm({ name: "", ticker: "", cg_id: "", menge: "", kaufkurs: "", farbe: "#f59e0b" });
    setShowForm(false);
  }

  async function analyze() {
    setAiLoading(true); setAiText("");
    const desc = enriched.map(k => `${k.ticker} (${k.name}): ${k.menge} Stück, Wert ${fmtEur(k.wert)}, Rendite ${k.rendite.toFixed(1)}%`).join(", ");
    const text = await askAI(`Analysiere dieses Krypto-Portfolio: ${desc}. Gesamtwert: ${fmtEur(total)}. Wie sinnvoll ist die Diversifikation? Risiken? (3-4 Sätze)`);
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div style={{ padding: "8px 16px", background: lastUpdate ? "var(--green-light)" : "var(--surface2)", borderRadius: 10, border: `1px solid ${lastUpdate ? "rgba(22,163,74,0.2)" : "var(--border)"}`, fontSize: 11, color: lastUpdate ? "var(--green)" : "var(--text3)", marginBottom: 16, display: "flex", gap: 6 }}>
        {lastUpdate ? `🟢 Live via CoinGecko · ${lastUpdate.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr` : positionen.length === 0 ? "Füge Coins hinzu um Live-Kurse zu laden" : <span className="dots">CoinGecko Live-Kurse laden</span>}
      </div>
      <div className="g3" style={{ marginBottom: 16 }}>
        <div className="metric"><div className="metric-label">Portfolio-Wert</div><div className="metric-value" style={{ color: "#f59e0b" }}>{fmtEur(total)}</div></div>
        <div className="metric"><div className="metric-label">Positionen</div><div className="metric-value c-text">{positionen.length}</div></div>
        <div className="metric">
          <div className="metric-label">BTC-Anteil</div>
          <div className="metric-value c-amber">
            {total > 0 ? `${((enriched.find(k => k.ticker === "BTC")?.wert || 0) / total * 100).toFixed(0)} %` : "–"}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-title" style={{ justifyContent: "space-between" }}>
          <span><span className="ct-icon">₿</span>Positionen · Live-Kurse</span>
          {canAdd
            ? <button className="btn btn-sm" onClick={() => setShowForm(!showForm)}>+ Coin hinzufügen</button>
            : <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ fontSize: 12, fontWeight: 700, color: "var(--teal)", textDecoration: "none", background: "var(--teal-light)", padding: "6px 12px", borderRadius: 7 }}>🔒 PRO – mehr Coins</a>}
        </div>

        {showForm && (
          <form onSubmit={handleAdd} style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 16, border: "1px solid var(--border)" }}>
            <div className="field">
              <label className="label">Coin auswählen</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
                {KRYPTO_DB.map(k => (
                  <span key={k.ticker}
                    onClick={() => setForm(f => ({ ...f, name: k.name, ticker: k.ticker, cg_id: k.cgId, farbe: { BTC: "#f59e0b", ETH: "#6366f1", SOL: "#8b5cf6", BNB: "#f0b90b", XRP: "#346aa9" }[k.ticker] || "#0d9488" }))}
                    style={{ background: form.ticker === k.ticker ? "var(--teal)" : "var(--bg)", color: form.ticker === k.ticker ? "white" : "var(--text2)", border: "1px solid var(--border)", borderRadius: 6, padding: "5px 12px", fontSize: 12, cursor: "pointer", fontWeight: 700 }}>
                    {k.ticker}
                  </span>
                ))}
              </div>
              {form.name && <div style={{ fontSize: 12, color: "var(--teal)", marginBottom: 8 }}>✓ {form.name} ({form.ticker}) · CoinGecko: {form.cg_id}</div>}
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Menge</label><input className="input" type="number" step="0.00001" placeholder="0.5" value={form.menge} onChange={set("menge")} required /></div>
              <div className="field"><label className="label">Kaufkurs (€)</label><input className="input" type="number" step="0.01" placeholder="45000" value={form.kaufkurs} onChange={set("kaufkurs")} required /></div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn" type="submit" disabled={!form.ticker}>Speichern</button>
              <button className="btn btn-ghost" type="button" onClick={() => setShowForm(false)}>Abbrechen</button>
            </div>
          </form>
        )}

        {loading ? <div className="empty"><span className="dots">Laden</span></div> :
          enriched.length === 0 ? <div className="empty">Noch keine Coins · Klick "+ Coin hinzufügen"</div> :
          enriched.map(k => (
            <div className="row-item" key={k.id}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 10, height: 10, borderRadius: "50%", background: k.farbe || "#f59e0b" }} />
                <div>
                  <div className="row-label">{k.ticker} · {k.menge} Stück</div>
                  <div className="row-sub">{k.name} · Kurs: {k.loading ? "…" : fmtEur(k.preis)}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <div className="row-right"><div className="row-val">{fmtEur(k.wert)}</div></div>
                <div className="row-right"><div className="row-val" style={{ color: k.rendite >= 0 ? "var(--green)" : "var(--red)" }}>{k.rendite >= 0 ? "+" : ""}{k.rendite.toFixed(1)} %</div><div className="row-sub">vs Kauf</div></div>
                <button onClick={() => remove(k.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 16 }}>✕</button>
              </div>
            </div>
          ))
        }
        {enriched.length > 0 && (
          <>
            <button className="btn btn-ghost btn-sm" style={{ marginTop: 14, width: "100%" }} onClick={analyze} disabled={aiLoading}>{aiLoading ? <span className="dots">KI analysiert</span> : "🤖 Portfolio analysieren"}</button>
            {aiText && <div className="ai-box"><div className="ai-label">🤖 KI-Analyse</div>{aiText}</div>}
          </>
        )}
      </div>
    </div>
  );
}

// ── LIQUIDITÄT DASHBOARD ──────────────────────────────────────────────────────
function LiquiditaetDashboard({ user }) {
  const { data: konten, loading, add, remove } = useUserData("liquiditaet", user?.id);
  const [showForm, setShowForm]   = useState(false);
  const [form, setForm]           = useState({ name: "", typ: "Tagesgeld", zinsen: "", betrag: "", faellig: "" });
  const [aiTipp, setAiTipp]       = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiAnalyse, setAiAnalyse]       = useState("");
  const [analyseLoading, setAnalyseLoading] = useState(false);
  const [tippGeladen, setTippGeladen]   = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const total           = konten.reduce((s, l) => s + (l.betrag || 0), 0);
  const jahresZinsen    = konten.reduce((s, l) => s + (l.betrag || 0) * ((l.zinsen || 0) / 100), 0);
  const unverzinst      = konten.filter(l => !l.zinsen || l.zinsen === 0).reduce((s, l) => s + (l.betrag || 0), 0);
  const entgangeneZinsen = unverzinst * 0.035;
  const zinstraeger     = konten.filter(l => l.zinsen > 0);
  const avgZins         = zinstraeger.length > 0
    ? zinstraeger.reduce((s, l) => s + (l.zinsen || 0), 0) / zinstraeger.length
    : 0;

  async function handleAdd(e) {
    e.preventDefault();
    await add({ ...form, zinsen: parseFloat(form.zinsen) || 0, betrag: parseFloat(form.betrag) || 0 });
    setForm({ name: "", typ: "Tagesgeld", zinsen: "", betrag: "", faellig: "" });
    setShowForm(false);
  }

  // FIX: analyzeKonten war nicht definiert – jetzt korrekt hinzugefügt
  async function analyzeKonten() {
    if (konten.length === 0) return;
    setAnalyseLoading(true); setAiAnalyse("");
    const desc = konten.map(l => `${l.name} (${l.typ}): ${fmtEur(l.betrag)}, ${l.zinsen || 0}% p.a.`).join("; ");
    const text = await askAI(`Analysiere diese Liquiditätspositionen detailliert: ${desc}. Gesamtliquidität: ${fmtEur(total)}, Unverzinst: ${fmtEur(unverzinst)}, Zinsen/Jahr: ${fmtEur(jahresZinsen)}. Gib konkrete Optimierungsempfehlungen: Welche Konten umschichten? Welche Produkte empfehlen? Nenne konkrete Anbieter und Zinssätze.`);
    setAiAnalyse(text); setAnalyseLoading(false);
  }

  useEffect(() => {
    if (tippGeladen || konten.length === 0) return;
    setAiLoading(true);
    const desc = konten.map(l => `${l.name}: ${fmtEur(l.betrag)}, ${l.zinsen || 0}% p.a.`).join("; ");
    askAI(`Finanzberater-Assistent: Analysiere Liquiditätspositionen: ${desc}. Gesamtliquidität: ${fmtEur(total)}. Unverzinst: ${fmtEur(unverzinst)}. Entgangene Zinsen bei 3,5%: ${fmtEur(entgangeneZinsen)}/Jahr. Schreibe 2-3 Sätze konkreten Tipp mit Euro-Beträgen.`)
      .then(text => { setAiTipp(text); setAiLoading(false); setTippGeladen(true); })
      .catch(() => { setAiTipp("Verschiebe unverzinstes Guthaben auf Tagesgeld und sichere bis zu 3,5% p.a."); setAiLoading(false); setTippGeladen(true); });
  }, [konten.length]);

  const affiliateProdukte = [
    ...(unverzinst > 500 ? [{ name: "DKB Tagesgeld", beschreibung: `${fmtEur(unverzinst)} unverzinst → ${fmtEur(entgangeneZinsen)}/Jahr entgehen dir`, cta: "Jetzt 3,5% sichern", link: "https://www.dkb.de/girokonto/", note: "financeads.net", highlight: true }] : []),
    { name: "WeltSparen Festgeld", beschreibung: "Bis 3,8% p.a. für 12 Monate", cta: "Festgeld vergleichen", link: "https://www.weltsparen.de/", note: "Raisin", highlight: false },
    { name: "Scalable Capital", beschreibung: "Liquidität automatisch mit 3,5% verzinsen", cta: "Depot eröffnen", link: "https://partner.scalable-capital.de/", note: "Scalable", highlight: false },
  ];

  return (
    <div>
      <div className="g3" style={{ marginBottom: 16 }}>
        <div className="metric"><div className="metric-label">Gesamt-Liquidität</div><div className="metric-value c-green">{fmtEur(total)}</div><div className="metric-sub">{konten.length} Konten</div></div>
        <div className="metric"><div className="metric-label">Ø Verzinsung</div><div className="metric-value c-teal">{avgZins.toFixed(1)} %</div><div className="metric-sub">p.a.</div></div>
        <div className="metric"><div className="metric-label">Zinsen / Jahr</div><div className="metric-value c-amber">{fmtEur(jahresZinsen)}</div><div className="metric-sub">vor Steuer{unverzinst > 0 && <span style={{ color: "var(--red)" }}> · +{fmtEur(entgangeneZinsen)} möglich</span>}</div></div>
      </div>

      <div className="g2">
        <div className="card">
          <div className="card-title" style={{ justifyContent: "space-between" }}>
            <span><span className="ct-icon">💰</span>Konten & Positionen</span>
            <button className="btn btn-sm" onClick={() => setShowForm(!showForm)}>+ Konto hinzufügen</button>
          </div>

          {showForm && (
            <form onSubmit={handleAdd} style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 16, border: "1px solid var(--border)" }}>
              <div className="input-row">
                <div className="field"><label className="label">Name</label><input className="input" placeholder="z.B. DKB Tagesgeld" value={form.name} onChange={set("name")} required /></div>
                <div className="field"><label className="label">Typ</label>
                  <select className="input" value={form.typ} onChange={set("typ")}>
                    <option>Tagesgeld</option><option>Festgeld</option><option>Girokonto</option><option>Sparkonto</option><option>Sonstiges</option>
                  </select>
                </div>
              </div>
              <div className="input-row">
                <div className="field"><label className="label">Betrag (€)</label><input className="input" type="number" placeholder="10000" value={form.betrag} onChange={set("betrag")} required /></div>
                <div className="field"><label className="label">Zinsen (% p.a.)</label><input className="input" type="number" step="0.01" placeholder="3.5" value={form.zinsen} onChange={set("zinsen")} /></div>
              </div>
              <div className="field"><label className="label">Fällig am (optional – für Festgeld)</label><input className="input" type="date" value={form.faellig} onChange={set("faellig")} /></div>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="btn" type="submit">Speichern</button>
                <button className="btn btn-ghost" type="button" onClick={() => setShowForm(false)}>Abbrechen</button>
              </div>
            </form>
          )}

          {loading ? <div className="empty"><span className="dots">Laden</span></div> :
            konten.length === 0 ? <div className="empty">Noch keine Konten · Klick "+ Konto hinzufügen"</div> :
            konten.map(l => (
              <div className="row-item" key={l.id || l.name}>
                <div>
                  <div className="row-label">{l.name}</div>
                  <div className="row-sub">{l.typ}{l.faellig ? ` · Fällig: ${new Date(l.faellig).toLocaleDateString("de-DE")}` : ""}</div>
                </div>
                <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                  <div className="row-right"><div className="row-val">{fmtEur(l.betrag || 0)}</div></div>
                  <div className="row-right">
                    <div className="row-val" style={{ color: l.zinsen > 0 ? "var(--green)" : "var(--red)" }}>
                      {l.zinsen > 0 ? `${l.zinsen} %` : "0 %"}
                    </div>
                    <div className="row-sub">p.a.</div>
                  </div>
                  <button onClick={() => remove(l.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 16 }}>✕</button>
                </div>
              </div>
            ))
          }
          {konten.length > 0 && (
            <>
              <button className="btn btn-ghost" style={{ marginTop: 14 }} onClick={analyzeKonten} disabled={analyseLoading}>
                {analyseLoading ? <span className="dots">KI analysiert</span> : "🤖 Detaillierte Analyse"}
              </button>
              {aiAnalyse && <div className="ai-box"><div className="ai-label">🤖 KI-Analyse</div>{aiAnalyse}</div>}
            </>
          )}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="card">
            <div className="card-title"><span className="ct-icon">🤖</span>KI-Tipp · Personalisiert</div>
            {aiLoading ? (
              <div style={{ fontSize: 13, color: "var(--text3)", fontStyle: "italic" }}><span className="dots">KI analysiert deine Konten</span></div>
            ) : aiTipp ? (
              <div style={{ fontSize: 13, color: "var(--text)", lineHeight: 1.7 }}>{aiTipp}</div>
            ) : (
              <div className="empty">Füge Konten hinzu um den KI-Tipp zu erhalten</div>
            )}
            {!aiLoading && unverzinst > 0 && (
              <div style={{ marginTop: 12, padding: "10px 14px", background: "var(--red-light)", borderRadius: 8, border: "1px solid rgba(220,38,38,0.15)", fontSize: 12, color: "var(--red)", display: "flex", alignItems: "center", gap: 8 }}>
                ⚠️ {fmtEur(unverzinst)} arbeiten nicht für dich · {fmtEur(entgangeneZinsen)}/Jahr entgehen dir
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-title"><span className="ct-icon">✦</span>Empfohlene Produkte</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {affiliateProdukte.map(p => (
                <div key={p.name} style={{ padding: "14px 16px", borderRadius: 10, background: p.highlight ? "var(--teal-light)" : "var(--surface2)", border: `1px solid ${p.highlight ? "rgba(13,148,136,0.25)" : "var(--border)"}` }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", marginBottom: 4 }}>{p.name}</div>
                  <div style={{ fontSize: 12, color: "var(--text2)", marginBottom: 10, lineHeight: 1.5 }}>{p.beschreibung}</div>
                  <a href={p.link} rel="nofollow sponsored" target="_blank"
                    style={{ display: "block", textAlign: "center", background: p.highlight ? "var(--teal)" : "var(--text)", color: "white", padding: "8px 16px", borderRadius: 7, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                    {p.cta} →
                  </a>
                  <div style={{ fontSize: 10, color: "var(--text3)", textAlign: "center", marginTop: 6 }}>* Partnerlink · {p.note} · Für dich kostenlos</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── VERGLEICHE ────────────────────────────────────────────────────────────────
function Vergleiche() {
  const produkte = [
    { name: "DKB Cash Konto", cat: "Girokonto", icon: "🏦", bg: "#e6faf7", rate: "0 €", rateSub: "Kontoführung/Monat", features: ["Kostenlose Visa-Karte", "Weltweit abheben gratis", "Bis 3,5% Tagesgeld-Zinsen", "Keine Mindesteingang"], badge: "#1 Empfehlung", badgeClass: "badge-teal", link: "https://www.dkb.de/girokonto/", note: "financeads.net" },
    { name: "Scalable Capital", cat: "ETF-Depot", icon: "📈", bg: "#eff6ff", rate: "0 €", rateSub: "Pro Sparplan-Ausführung", features: ["2.000+ ETFs kostenlos", "Sparplan ab 1 € möglich", "Zinsen auf Verrechnungskonto", "BaFin-reguliert"], badge: "#1 Depot", badgeClass: "badge-blue", link: "https://partner.scalable-capital.de/", note: "Scalable Capital" },
    { name: "CHECK24 Vergleich", cat: "Versicherung & Kredit", icon: "🛡️", bg: "#fef8ec", rate: "bis 40 €", rateSub: "Ersparnis pro Abschluss", features: ["Kfz, Haftpflicht, BU & mehr", "Kredit ab 3,99% p.a.", "SCHUFA-neutrale Anfrage", "Sofortentscheidung online"], badge: "Beste Preise", badgeClass: "badge-amber", link: "https://www.check24-partnerprogramm.de/", note: "CHECK24" },
  ];

  return (
    <div>
      <div style={{ marginBottom: 20, padding: "14px 18px", background: "var(--teal-light)", borderRadius: 10, border: "1px solid rgba(13,148,136,0.2)", fontSize: 13, color: "var(--teal)" }}>
        💡 Diese Vergleiche sind direkt in deine Growvly-Plattform integriert. Durch Partnerlinks finanzierst du diese Plattform – für dich entstehen keine Mehrkosten.
      </div>
      <div className="g3">
        {produkte.map(p => (
          <div className="aff-card" key={p.name}>
            <div className="aff-header">
              <div className="aff-icon" style={{ background: p.bg }}>{p.icon}</div>
              <div>
                <div className="aff-name">{p.name}</div>
                <div className="aff-cat">{p.cat}</div>
                <span className={`badge ${p.badgeClass}`} style={{ marginTop: 4, display: "inline-block" }}>{p.badge}</span>
              </div>
            </div>
            <div>
              <div className="aff-rate">{p.rate}</div>
              <div className="aff-rate-sub">{p.rateSub}</div>
            </div>
            <ul className="aff-features">{p.features.map(f => <li key={f}>{f}</li>)}</ul>
            <a href={p.link} rel="nofollow sponsored" target="_blank" className="aff-btn">Jetzt zum Angebot →</a>
            <div className="aff-note">* Partnerlink · {p.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── KI ASSISTENT ──────────────────────────────────────────────────────────────
function KIAssistent({ user, profile }) {
  const { data: immobilien }       = useUserData("immobilien", user?.id);
  const { data: etfPositionen }    = useUserData("etf_positionen", user?.id);
  const { data: kryptoPositionen } = useUserData("krypto_positionen", user?.id);
  const { data: liquiditaet }      = useUserData("liquiditaet", user?.id);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Hallo! Ich bin dein persönlicher Finanz- und Immobilienberater. Ich kenne dein Portfolio und kann dir zu allen Themen helfen – von Immobilien-Investitionen bis zu ETF-Strategien und Steueroptimierung. Was möchtest du wissen?" }
  ]);
  const [input, setInput]   = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const immoSummary = `Nutzer: ${profile?.name || user?.email}. Portfolio: ${immobilien.length} Immobilien (${fmtEur(immobilien.reduce((s,p)=>s+(p.aktueller_wert||0),0))}), ${etfPositionen.length} ETF/Aktien, ${kryptoPositionen.length} Krypto, Liquidität: ${fmtEur(liquiditaet.reduce((s,l)=>s+(l.betrag||0),0))}.`;

  async function send() {
    if (!input.trim() || loading) return;
    const userMsg = input.trim(); setInput("");
    const newMessages = [...messages, { role: "user", text: userMsg }];
    setMessages(newMessages);
    setLoading(true);
    // FIX 5: Only send last 10 messages to avoid token explosion
    const recentHistory = newMessages.slice(-10).map(m => `${m.role === "user" ? "Nutzer" : "Berater"}: ${m.text}`).join("\n");
    const text = await askAI(
      `${immoSummary}\n\nGesprächsverlauf (letzte Nachrichten):\n${recentHistory}\n\nNutzer: ${userMsg}`,
      "Du bist ein hilfreicher KI-Assistent für Finanz- und Immobilienthemen. Gib sachliche, informative Antworten auf Basis des bekannten Portfolios. Weise bei konkreten Anlageentscheidungen darauf hin, dass ein Fachberater konsultiert werden sollte. Kein Markdown, kein Sternchen-Formatting. Maximal 4 Sätze pro Antwort."
    );
    setMessages(m => [...m, { role: "assistant", text }]);
    setLoading(false);
  }

  const starters = ["Sollte ich mein ETF-Portfolio rebalancen?", "Wie optimiere ich meine Immobilien steuerlich?", "Welches Objekt sollte ich als nächstes kaufen?", "Wie schütze ich mein Vermögen vor Inflation?"];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 160px)" }}>
      <div style={{ flex: 1, overflowY: "auto", paddingBottom: 16 }}>
        {messages.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start", marginBottom: 12 }}>
            {m.role === "assistant" && (
              <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg, var(--teal), var(--blue))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, marginRight: 10, flexShrink: 0 }}>🤖</div>
            )}
            <div style={{ maxWidth: "70%", padding: "12px 16px", borderRadius: 12, background: m.role === "user" ? "var(--teal)" : "var(--surface)", color: m.role === "user" ? "white" : "var(--text)", border: m.role === "assistant" ? "1px solid var(--border)" : "none", fontSize: 13.5, lineHeight: 1.6, boxShadow: "var(--shadow)" }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg, var(--teal), var(--blue))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>🤖</div>
            <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: "12px 16px", fontSize: 13, color: "var(--text3)" }}><span className="dots">Denkt nach</span></div>
          </div>
        )}
        {messages.length === 1 && (
          <div className="chips" style={{ marginTop: 8 }}>
            {starters.map(s => <span key={s} className="chip" onClick={() => setInput(s)}>{s}</span>)}
          </div>
        )}
        <div ref={bottomRef} />
      </div>
      <div style={{ display: "flex", gap: 10, paddingTop: 14, borderTop: "1px solid var(--border)" }}>
        <input className="input" style={{ flex: 1 }} placeholder="Frag deinen Finanzberater..." value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} />
        <button className="btn" style={{ width: "auto", padding: "10px 20px" }} onClick={send} disabled={loading || !input.trim()}>Senden</button>
      </div>
    </div>
  );
}

// ── ALLE ASSETS ───────────────────────────────────────────────────────────────
function AlleAssets({ setPage, user }) {
  const { data: immobilien }       = useUserData("immobilien", user?.id);
  const { data: etfPositionen }    = useUserData("etf_positionen", user?.id);
  const { data: kryptoPositionen } = useUserData("krypto_positionen", user?.id);
  const { data: liquiditaet }      = useUserData("liquiditaet", user?.id);
  const { preise: kryptoPreise }   = useKryptoLiveForPositionen(kryptoPositionen);

  const immoWert      = immobilien.reduce((s, p) => s + Math.max(0, (p.aktueller_wert || 0) - (p.restschuld || 0)), 0);
  const etfWert       = etfPositionen.reduce((s, e) => s + ((e.anteile || 0) * (e.kaufkurs || 0)), 0);
  const kryptoWert    = kryptoPositionen.reduce((s, k) => {
    const preis = k.cg_id && kryptoPreise[k.cg_id] ? kryptoPreise[k.cg_id] : (k.kaufkurs || 0);
    return s + (k.menge || 0) * preis;
  }, 0);
  const liquidWert    = liquiditaet.reduce((s, l) => s + (l.betrag || 0), 0);
  const total         = immoWert + etfWert + kryptoWert + liquidWert;

  const klassen = [
    { label: "Immobilien",  wert: immoWert,      icon: "🏘️", farbe: "#0d9488", page: "immo-portfolio", items: `${immobilien.length} Objekte` },
    { label: "ETF & Aktien", wert: etfWert,      icon: "📈", farbe: "#2563eb", page: "etf",            items: `${etfPositionen.length} Positionen` },
    { label: "Krypto",      wert: kryptoWert,    icon: "₿",  farbe: "#f59e0b", page: "krypto",         items: `${kryptoPositionen.length} Coins` },
    { label: "Liquidität",  wert: liquidWert,    icon: "💰", farbe: "#16a34a", page: "liquiditaet",    items: `${liquiditaet.length} Konten` },
  ];

  return (
    <div>
      <div className="g4" style={{ marginBottom: 20 }}>
        <div className="metric"><div className="metric-label">Gesamtvermögen</div><div className="metric-value c-text">{fmtEur(total)}</div></div>
        <div className="metric"><div className="metric-label">Asset-Klassen</div><div className="metric-value c-text">{klassen.filter(k => k.wert > 0).length}</div><div className="metric-sub">mit Positionen</div></div>
        <div className="metric"><div className="metric-label">Größte Position</div><div className="metric-value c-teal">{klassen.length > 0 ? fmtEur(Math.max(...klassen.map(k => k.wert))) : "–"}</div></div>
        <div className="metric"><div className="metric-label">Liquiditätsquote</div><div className="metric-value c-green">{total > 0 ? ((liquidWert / total) * 100).toFixed(0) : 0} %</div></div>
      </div>
      <div className="g2">
        <div className="card">
          <div className="card-title"><span className="ct-icon">📊</span>Alle Asset-Klassen</div>
          {total === 0 ? <div className="empty">Noch keine Assets · Füge Positionen in den einzelnen Modulen hinzu</div> :
            klassen.map(k => (
              <div className="row-item" key={k.label} style={{ cursor: k.page ? "pointer" : "default" }} onClick={() => k.page && setPage(k.page)}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: k.farbe }} />
                  <div><div className="row-label">{k.icon} {k.label}</div><div className="row-sub">{k.items}</div></div>
                </div>
                <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                  <div className="row-right"><div className="row-val">{fmtEur(k.wert)}</div><div className="row-sub">{total > 0 ? ((k.wert / total) * 100).toFixed(0) : 0} %</div></div>
                  {k.page && <span style={{ color: "var(--text3)" }}>›</span>}
                </div>
              </div>
            ))
          }
        </div>
        <div className="card">
          <div className="card-title"><span className="ct-icon">🥧</span>Allokation</div>
          {total === 0 ? <div className="empty">Keine Daten</div> :
            klassen.filter(k => k.wert > 0).map(k => (
              <div key={k.label} style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ fontSize: 12, fontWeight: 500 }}>{k.icon} {k.label}</span>
                  <span style={{ fontSize: 12, color: "var(--text2)" }}>{((k.wert / total) * 100).toFixed(0)} %</span>
                </div>
                <div className="alloc-bar"><div className="alloc-fill" style={{ width: `${(k.wert / total) * 100}%`, background: k.farbe }} /></div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

// ── DIVIDENDEN KALENDER ───────────────────────────────────────────────────────
// Hybridansatz: Nutzer trägt Dividenden manuell ein, KI schätzt Prognosen
const DIVIDENDEN_RHYTHMUS = {
  // Bekannte ETF-Ausschüttungsrhythmen (manuell gepflegt)
  "VWCE": { rhythmus: "jährlich", monat: 3, typDividende: "Ausschüttung" },
  "IWDA": { rhythmus: "quartalsweise", monate: [3,6,9,12], typDividende: "Ausschüttung" },
  "EIMI": { rhythmus: "quartalsweise", monate: [3,6,9,12], typDividende: "Ausschüttung" },
  "CSPX": { rhythmus: "quartalsweise", monate: [1,4,7,10], typDividende: "Ausschüttung" },
  "EXS1": { rhythmus: "halbjährlich", monate: [6,12], typDividende: "Ausschüttung" },
  "EXSA": { rhythmus: "halbjährlich", monate: [6,12], typDividende: "Ausschüttung" },
  "AAPL": { rhythmus: "quartalsweise", monate: [2,5,8,11], typDividende: "Dividende" },
  "MSFT": { rhythmus: "quartalsweise", monate: [3,6,9,12], typDividende: "Dividende" },
  "ALV":  { rhythmus: "jährlich", monat: 5, typDividende: "Dividende" },
  "SAP":  { rhythmus: "jährlich", monat: 5, typDividende: "Dividende" },
  "MUV2": { rhythmus: "jährlich", monat: 5, typDividende: "Dividende" },
  "SIE":  { rhythmus: "jährlich", monat: 2, typDividende: "Dividende" },
};

const MONATE_DE = ["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"];

function DividendenKalender({ user, isPro }) {
  const { data: etfPositionen } = useUserData("etf_positionen", user?.id);
  const { data: immobilien }    = useUserData("immobilien", user?.id);
  const { data: liquiditaet }   = useUserData("liquiditaet", user?.id);
  const { data: dividenden, add: addDiv, remove: removeDiv } = useUserData("dividenden", user?.id);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", betrag: "", datum: "", typ: "Dividende", ticker: "" });
  const [aiPrognose, setAiPrognose] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  // Passives Einkommen berechnen
  const immoMiete   = immobilien.reduce((s, p) => s + (p.miete || 0), 0);
  const liquidZinsen = liquiditaet.reduce((s, l) => s + (l.betrag || 0) * ((l.zinsen || 0) / 100) / 12, 0);
  const divJahr     = dividenden.reduce((s, d) => s + (d.betrag || 0), 0);
  const gesamtPassiv = immoMiete + liquidZinsen + divJahr / 12;

  // Kalenderansicht: Dividenden nach Monat gruppieren
  const jetzt = new Date();
  const kalender = Array.from({ length: 12 }, (_, i) => {
    const monat = (jetzt.getMonth() + i) % 12;
    const jahr  = jetzt.getFullYear() + Math.floor((jetzt.getMonth() + i) / 12);
    const divInMonat = dividenden.filter(d => {
      if (!d.datum) return false;
      const dd = new Date(d.datum);
      return dd.getMonth() === monat && dd.getFullYear() === jahr;
    });
    return { monat, jahr, divInMonat, total: divInMonat.reduce((s, d) => s + (d.betrag || 0), 0) };
  });

  // KI-Prognose für nächstes Jahr
  async function generierePrognose() {
    setAiLoading(true); setAiPrognose("");
    const etfInfo = etfPositionen.map(e => `${e.ticker} (${e.anteile} Anteile, Kaufkurs ${fmtEur(e.kaufkurs)})`).join(", ");
    const divInfo = dividenden.map(d => `${d.name}: ${fmtEur(d.betrag)} am ${d.datum}`).join(", ");
    const text = await askAI(
      `Analysiere dieses ETF/Aktien-Portfolio und schätze die Dividendeneinnahmen für die nächsten 12 Monate:
ETF/Aktien: ${etfInfo || "keine"}
Bereits eingetragene Dividenden: ${divInfo || "keine"}
Immobilien-Mieteinnahmen: ${fmtEur(immoMiete)}/Monat
Liquiditätszinsen: ${fmtEur(liquidZinsen)}/Monat (geschätzt)

Gib eine Prognose: 1) Geschätzte Jahres-Dividenden in Euro 2) Welche Monate sind typischerweise ertragsreich? 3) Optimierungsempfehlung für mehr passives Einkommen. Max 4 Sätze.`,
      "Du bist ein hilfreicher KI-Assistent für Finanzthemen. Antworte auf Deutsch, ohne Markdown, ohne Sternchen. Keine Anlageberatung."
    );
    setAiPrognose(text); setAiLoading(false);
  }

  async function handleAdd(e) {
    e.preventDefault();
    await addDiv({ ...form, betrag: parseFloat(form.betrag) || 0 });
    setForm({ name: "", betrag: "", datum: "", typ: "Dividende", ticker: "" });
    setShowForm(false);
  }

  return (
    <div>
      {/* Jahresübersicht */}
      <div className="g4" style={{ marginBottom: 16 }}>
        <div className="metric"><div className="metric-label">Dividenden/Jahr</div><div className="metric-value c-green">{fmtEur(divJahr)}</div><div className="metric-sub">{dividenden.length} Einträge</div></div>
        <div className="metric"><div className="metric-label">Mieteinnahmen/Mo</div><div className="metric-value c-teal">{fmtEur(immoMiete)}</div></div>
        <div className="metric"><div className="metric-label">Zinsen/Mo</div><div className="metric-value c-blue">{fmtEur(liquidZinsen)}</div><div className="metric-sub">geschätzt</div></div>
        <div className="metric"><div className="metric-label">Gesamt passiv/Mo</div><div className="metric-value c-amber">{fmtEur(gesamtPassiv)}</div><div className="metric-sub">∅ alle Quellen</div></div>
      </div>

      {/* Kalender */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title" style={{ justifyContent: "space-between" }}>
          <span><span className="ct-icon">📅</span>Dividendenkalender – nächste 12 Monate</span>
          <button className="btn btn-sm" onClick={() => setShowForm(!showForm)}>+ Dividende eintragen</button>
        </div>

        {showForm && (
          <form onSubmit={handleAdd} style={{ background: "var(--surface2)", borderRadius: 10, padding: 16, marginBottom: 16, border: "1px solid var(--border)" }}>
            <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 10 }}>
              Trage erhaltene oder erwartete Dividenden/Ausschüttungen manuell ein. Die KI erstellt danach eine Prognose.
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Bezeichnung</label><input className="input" placeholder="z.B. VWCE Ausschüttung" value={form.name} onChange={set("name")} required /></div>
              <div className="field"><label className="label">Typ</label>
                <select className="input" value={form.typ} onChange={set("typ")}>
                  <option>Dividende</option><option>Ausschüttung (ETF)</option><option>Zinsen</option><option>Sonstige</option>
                </select>
              </div>
            </div>
            <div className="input-row">
              <div className="field"><label className="label">Betrag (€)</label><input className="input" type="number" step="0.01" placeholder="45.00" value={form.betrag} onChange={set("betrag")} required /></div>
              <div className="field"><label className="label">Datum (erhalten/erwartet)</label><input className="input" type="date" value={form.datum} onChange={set("datum")} required /></div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn" type="submit">Speichern</button>
              <button className="btn btn-ghost" type="button" onClick={() => setShowForm(false)}>Abbrechen</button>
            </div>
          </form>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 }}>
          {kalender.map(({ monat, jahr, divInMonat, total }, i) => (
            <div key={i} style={{ background: i === 0 ? "var(--teal-light)" : "var(--surface2)", border: `1px solid ${i === 0 ? "rgba(13,148,136,0.3)" : "var(--border)"}`, borderRadius: 8, padding: "10px 12px" }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: i === 0 ? "var(--teal)" : "var(--text3)", textTransform: "uppercase", marginBottom: 4 }}>
                {MONATE_DE[monat]} {jahr !== jetzt.getFullYear() ? jahr : ""}
              </div>
              {divInMonat.length === 0 ? (
                <div style={{ fontSize: 11, color: "var(--text3)" }}>–</div>
              ) : (
                <>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "var(--green)" }}>{fmtEur(total)}</div>
                  {divInMonat.map(d => (
                    <div key={d.id} style={{ fontSize: 11, color: "var(--text2)", marginTop: 2, display: "flex", justifyContent: "space-between" }}>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "70%" }}>{d.name}</span>
                      <button onClick={() => removeDiv(d.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 11, padding: 0 }}>✕</button>
                    </div>
                  ))}
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* KI-Prognose */}
      <div className="card">
        <div className="card-title"><span className="ct-icon">🤖</span>KI-Jahresprognose</div>
        {isPro ? (
          <>
            <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 14 }}>
              Die KI analysiert dein Portfolio und schätzt deine Dividendeneinnahmen für die nächsten 12 Monate – inklusive Tipps zur Optimierung.
            </div>
            <button className="btn" onClick={generierePrognose} disabled={aiLoading} style={{ marginBottom: 14 }}>
              {aiLoading ? <span className="dots">KI erstellt Prognose</span> : "📊 Prognose erstellen"}
            </button>
            {aiPrognose && <div className="ai-box"><div className="ai-label">🤖 KI-Dividendenprognose</div>{aiPrognose}</div>}
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ fontSize: 13, color: "var(--text2)", flex: 1 }}>KI-Jahresprognose ist ein PRO-Feature.</div>
            <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ background: "var(--teal)", color: "white", padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none", whiteSpace: "nowrap" }}>PRO upgraden →</a>
          </div>
        )}
      </div>
    </div>
  );
}

// ── PASSIVES EINKOMMEN DASHBOARD ──────────────────────────────────────────────
function PassivesEinkommen({ user, isPro }) {
  const { data: immobilien }  = useUserData("immobilien", user?.id);
  const { data: etfPos }      = useUserData("etf_positionen", user?.id);
  const { data: liquiditaet } = useUserData("liquiditaet", user?.id);
  const { data: dividenden }  = useUserData("dividenden", user?.id);
  const [aiText, setAiText]   = useState("");
  const [aiLoading, setAiLoading] = useState(false);

  const immoMiete    = immobilien.reduce((s, p) => s + (p.miete || 0), 0);
  const liquidZinsen = liquiditaet.reduce((s, l) => s + (l.betrag || 0) * ((l.zinsen || 0) / 100) / 12, 0);
  const divMonat     = dividenden.reduce((s, d) => s + (d.betrag || 0), 0) / 12;
  const gesamt       = immoMiete + liquidZinsen + divMonat;

  // Jahreshochrechnung
  const jahresEinkommen = gesamt * 12;

  // Quellen für Balkendiagramm
  const quellen = [
    { label: "Mieteinnahmen", wert: immoMiete, farbe: "#0d9488", icon: "🏘️" },
    { label: "Zinsen",        wert: liquidZinsen, farbe: "#2563eb", icon: "🏦" },
    { label: "Dividenden/∅",  wert: divMonat,  farbe: "#16a34a", icon: "📈" },
  ].filter(q => q.wert > 0);

  const max = Math.max(...quellen.map(q => q.wert), 1);

  // FIRE-Einschätzung (4%-Regel rückwärts)
  const benoetigtesKapital = gesamt > 0 ? (gesamt * 12) / 0.04 : 0;

  async function analyze() {
    setAiLoading(true); setAiText("");
    const text = await askAI(
      `Analysiere dieses passive Einkommen: Mieteinnahmen ${fmtEur(immoMiete)}/Mo, Zinsen ${fmtEur(liquidZinsen)}/Mo, Dividenden ∅${fmtEur(divMonat)}/Mo, Gesamt ${fmtEur(gesamt)}/Mo (${fmtEur(jahresEinkommen)}/Jahr).
Gib 3 konkrete Empfehlungen: 1) Wie kann das passive Einkommen gesteigert werden? 2) Welche Quelle hat das größte Wachstumspotenzial? 3) Was fehlt noch? Max 4 Sätze.`,
      "Du bist Finanzberater. Antworte auf Deutsch, ohne Markdown."
    );
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div className="g4" style={{ marginBottom: 20 }}>
        <div className="metric"><div className="metric-label">Passiv gesamt/Mo</div><div className="metric-value c-green">{fmtEur(gesamt)}</div><div className="metric-sub">alle Quellen</div></div>
        <div className="metric"><div className="metric-label">Passiv/Jahr</div><div className="metric-value c-teal">{fmtEur(jahresEinkommen)}</div></div>
        <div className="metric"><div className="metric-label">Mieteinnahmen</div><div className="metric-value c-amber">{fmtEur(immoMiete)}/Mo</div></div>
        <div className="metric"><div className="metric-label">Kapital f. FIRE (4%)</div><div className="metric-value c-text" style={{ fontSize: 18 }}>{gesamt > 0 ? fmtEur(benoetigtesKapital) : "–"}</div><div className="metric-sub">für aktuellen Lebensstandard</div></div>
      </div>

      <div className="g2" style={{ marginBottom: 16 }}>
        <div className="card">
          <div className="card-title"><span className="ct-icon">💸</span>Einkommensquellen</div>
          {quellen.length === 0 ? (
            <div className="empty">Noch keine Daten · Füge Immobilien, Konten und Dividenden hinzu</div>
          ) : (
            quellen.map(q => (
              <div key={q.label} style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ fontSize: 13, fontWeight: 600 }}>{q.icon} {q.label}</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: q.farbe }}>{fmtEur(q.wert)}/Mo</span>
                </div>
                <div className="alloc-bar">
                  <div className="alloc-fill" style={{ width: `${(q.wert / max) * 100}%`, background: q.farbe }} />
                </div>
                <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 3 }}>
                  {fmtEur(q.wert * 12)}/Jahr · {gesamt > 0 ? ((q.wert / gesamt) * 100).toFixed(0) : 0}% des Gesamteinkommens
                </div>
              </div>
            ))
          )}
          <hr className="divider" />
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 700 }}>
            <span>Gesamt passiv</span>
            <span style={{ color: "var(--green)" }}>{fmtEur(gesamt)}/Mo · {fmtEur(jahresEinkommen)}/Jahr</span>
          </div>
        </div>

        <div className="card">
          <div className="card-title"><span className="ct-icon">🎯</span>Meilensteine</div>
          {[
            { ziel: 500,   label: "500 €/Mo – Nebenkosten gedeckt" },
            { ziel: 1000,  label: "1.000 €/Mo – Miete gedeckt" },
            { ziel: 2000,  label: "2.000 €/Mo – Lean FIRE" },
            { ziel: 3000,  label: "3.000 €/Mo – Regular FIRE" },
            { ziel: 5000,  label: "5.000 €/Mo – Fat FIRE" },
          ].map(m => {
            const pct = Math.min((gesamt / m.ziel) * 100, 100);
            const erreicht = gesamt >= m.ziel;
            return (
              <div key={m.ziel} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: erreicht ? "var(--green)" : "var(--text2)", fontWeight: erreicht ? 700 : 400 }}>
                    {erreicht ? "✓ " : ""}{m.label}
                  </span>
                  <span style={{ fontSize: 12, color: "var(--text3)" }}>{pct.toFixed(0)}%</span>
                </div>
                <div className="alloc-bar">
                  <div className="alloc-fill" style={{ width: `${pct}%`, background: erreicht ? "var(--green)" : "var(--teal)" }} />
                </div>
              </div>
            );
          })}

          <hr className="divider" />
          {isPro ? (
            <>
              <button className="btn btn-ghost btn-sm" style={{ width: "100%", marginTop: 8 }} onClick={analyze} disabled={aiLoading}>
                {aiLoading ? <span className="dots">KI analysiert</span> : "🤖 KI-Optimierungstipps"}
              </button>
              {aiText && <div className="ai-box" style={{ marginTop: 12 }}><div className="ai-label">🤖 Empfehlungen</div>{aiText}</div>}
            </>
          ) : (
            <a href="https://buy.stripe.com/7sYbJ35Fzb887g46sR6Ri00" target="_blank" style={{ display: "block", textAlign: "center", background: "var(--teal-light)", color: "var(--teal)", padding: "8px", borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: "none", marginTop: 8 }}>PRO für KI-Tipps →</a>
          )}
        </div>
      </div>
    </div>
  );
}

// ── STEUER MODUL ──────────────────────────────────────────────────────────────
function SteuerModul({ user, isPro }) {
  const { data: etfPos }      = useUserData("etf_positionen", user?.id);
  const { data: liquiditaet } = useUserData("liquiditaet", user?.id);
  const { data: dividenden }  = useUserData("dividenden", user?.id);
  const { data: immobilien }  = useUserData("immobilien", user?.id);
  const [fsaAufteilung, setFsaAufteilung] = useState([
    { broker: "Scalable Capital", betrag: 600 },
    { broker: "DKB", betrag: 400 },
  ]);
  const [aiText, setAiText]   = useState("");
  const [aiLoading, setAiLoading] = useState(false);

  const FSA_LIMIT = 1000; // € Sparerpauschbetrag 2026

  // Kapitalerträge schätzen
  const divJahr     = dividenden.reduce((s, d) => s + (d.betrag || 0), 0);
  const zinsenJahr  = liquiditaet.reduce((s, l) => s + (l.betrag || 0) * ((l.zinsen || 0) / 100), 0);
  const gesamtErtraege = divJahr + zinsenJahr;
  const fsaGenutzt  = Math.min(gesamtErtraege, FSA_LIMIT);
  const steuerpflichtig = Math.max(gesamtErtraege - FSA_LIMIT, 0);
  const steuerLast  = steuerpflichtig * 0.26375; // 25% + Soli
  const fsaProzent  = Math.min((gesamtErtraege / FSA_LIMIT) * 100, 100);
  const fsaAufteilungGesamt = fsaAufteilung.reduce((s, f) => s + f.betrag, 0);

  // Immobilien AfA (2% auf 70% des Kaufpreises für Neubauten, 2,5% für Altbauten)
  const immoAfA = immobilien.reduce((s, p) => s + (p.kaufpreis || 0) * 0.7 * 0.02, 0);

  // ETF Vorabpauschale (vereinfacht: Basiszins ~2,5% × 0,7 × ETF-Wert)
  const etfWert = etfPos.reduce((s, e) => s + (e.anteile || 0) * (e.kaufkurs || 0), 0);
  const vorabpauschale = etfWert * 0.025 * 0.7; // Näherung

  async function analyze() {
    setAiLoading(true); setAiText("");
    const text = await askAI(
      `Analysiere diese steuerliche Situation eines deutschen Anlegers 2026:
Kapitalerträge (Dividenden + Zinsen): ${fmtEur(gesamtErtraege)}/Jahr
Freistellungsauftrag genutzt: ${fmtEur(fsaGenutzt)} von 1.000 €
Steuerpflichtige Erträge: ${fmtEur(steuerpflichtig)}
Abgeltungssteuer geschätzt: ${fmtEur(steuerLast)}
ETF-Vorabpauschale (Näherung): ${fmtEur(vorabpauschale)}
Immobilien-AfA (Näherung): ${fmtEur(immoAfA)}/Jahr
Gib 3 konkrete Steuer-Spartipps. Max 4 Sätze. Kein Steuerberater, nur allgemeine Information.`,
      "Du bist Finanzredakteur. Antworte auf Deutsch, ohne Markdown, ohne Sternchen. Weise am Ende darauf hin, dass das keine Steuerberatung ist."
    );
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div style={{ padding: "12px 16px", background: "var(--amber-light)", borderRadius: 10, border: "1px solid rgba(217,119,6,0.2)", fontSize: 13, color: "var(--amber)", marginBottom: 20 }}>
        ⚠️ Growvly ist kein Steuerberater. Alle Angaben sind Schätzungen zur Orientierung. Für verbindliche Aussagen wende dich an einen Steuerberater oder nutze ELSTER.
      </div>

      <div className="g2" style={{ marginBottom: 16 }}>
        {/* FSA Tracker */}
        <div className="card">
          <div className="card-title"><span className="ct-icon">🛡️</span>Freistellungsauftrag 2026</div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 13 }}>Genutzt (geschätzt)</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: fsaProzent >= 100 ? "var(--red)" : fsaProzent >= 80 ? "var(--amber)" : "var(--green)" }}>
                {fmtEur(fsaGenutzt)} / 1.000 €
              </span>
            </div>
            <div className="alloc-bar" style={{ height: 12 }}>
              <div className="alloc-fill" style={{ width: `${fsaProzent}%`, background: fsaProzent >= 100 ? "var(--red)" : fsaProzent >= 80 ? "var(--amber)" : "var(--green)" }} />
            </div>
            <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>
              {fsaProzent >= 100
                ? `⚠️ FSA ausgeschöpft – ${fmtEur(steuerLast)} Steuer fällig`
                : `Noch ${fmtEur(FSA_LIMIT - fsaGenutzt)} bis zum Limit frei`}
            </div>
          </div>

          <hr className="divider" />
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>FSA-Aufteilung auf Broker</div>
          {fsaAufteilung.map((f, i) => (
            <div key={i} className="row-item">
              <span style={{ fontSize: 13 }}>{f.broker}</span>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input type="number" value={f.betrag} onChange={e => setFsaAufteilung(prev => prev.map((x, j) => j === i ? { ...x, betrag: parseFloat(e.target.value) || 0 } : x))}
                  style={{ width: 80, padding: "4px 8px", borderRadius: 6, border: "1px solid var(--border)", background: "var(--surface2)", fontSize: 13, color: "var(--text)" }} />
                <span style={{ fontSize: 13, color: "var(--text2)" }}>€</span>
              </div>
            </div>
          ))}
          <div style={{ fontSize: 12, color: fsaAufteilungGesamt > FSA_LIMIT ? "var(--red)" : "var(--text3)", marginTop: 8 }}>
            Gesamt: {fmtEur(fsaAufteilungGesamt)} {fsaAufteilungGesamt > FSA_LIMIT ? "⚠️ ÜBERSCHREITUNG!" : "✓ ok"}
          </div>
        </div>

        {/* Steuerübersicht */}
        <div className="card">
          <div className="card-title"><span className="ct-icon">📊</span>Steuerübersicht 2026 (Schätzung)</div>
          {[
            { label: "Dividenden (Jahr)", wert: divJahr, farbe: "var(--green)" },
            { label: "Zinsen (Jahr)", wert: zinsenJahr, farbe: "var(--blue)" },
            { label: "Kapitalerträge gesamt", wert: gesamtErtraege, farbe: "var(--text)", bold: true },
            { label: "− Freistellungsauftrag", wert: -fsaGenutzt, farbe: "var(--teal)" },
            { label: "= Steuerpflichtig", wert: steuerpflichtig, farbe: steuerpflichtig > 0 ? "var(--red)" : "var(--green)", bold: true },
            { label: "Abgeltungssteuer (26,375%)", wert: steuerLast, farbe: "var(--red)" },
          ].map(row => (
            <div key={row.label} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px solid var(--border)", fontSize: 13, fontWeight: row.bold ? 700 : 400 }}>
              <span style={{ color: "var(--text2)" }}>{row.label}</span>
              <span style={{ color: row.farbe }}>{row.wert >= 0 ? "" : "−"}{fmtEur(Math.abs(row.wert))}</span>
            </div>
          ))}
          <hr className="divider" />
          <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 8, lineHeight: 1.6 }}>
            <strong style={{ color: "var(--text2)" }}>Immobilien AfA (Näherung):</strong> {fmtEur(immoAfA)}/Jahr steuerlich absetzbar<br />
            <strong style={{ color: "var(--text2)" }}>ETF Vorabpauschale (Näherung):</strong> {fmtEur(vorabpauschale)} für 2026
          </div>
          {isPro && (
            <>
              <button className="btn btn-ghost btn-sm" style={{ width: "100%", marginTop: 14 }} onClick={analyze} disabled={aiLoading}>
                {aiLoading ? <span className="dots">KI analysiert</span> : "🤖 Steuer-Spartipps von KI"}
              </button>
              {aiText && <div className="ai-box" style={{ marginTop: 12 }}><div className="ai-label">🤖 KI-Hinweise</div>{aiText}</div>}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ── PERFORMANCE TRACKER ───────────────────────────────────────────────────────
function PerformanceTracker({ user }) {
  const { data: etfPos }      = useUserData("etf_positionen", user?.id);
  const { data: kryptoPos }   = useUserData("krypto_positionen", user?.id);
  const { data: immobilien }  = useUserData("immobilien", user?.id);
  const { data: liquiditaet } = useUserData("liquiditaet", user?.id);
  const { preise: kryptoPreise } = useKryptoLiveForPositionen(kryptoPos);
  const [aiText, setAiText]   = useState("");
  const [aiLoading, setAiLoading] = useState(false);

  // Aktueller Gesamtwert
  const etfWert     = etfPos.reduce((s, e) => s + (e.anteile || 0) * (e.kaufkurs || 0), 0);
  const etfKosten   = etfPos.reduce((s, e) => s + (e.anteile || 0) * (e.kaufkurs || 0), 0); // Kaufwert = aktuell (keine Live-Kurse ohne Key)
  const kryptoWert  = kryptoPos.reduce((s, k) => {
    const preis = k.cg_id && kryptoPreise[k.cg_id] ? kryptoPreise[k.cg_id] : (k.kaufkurs || 0);
    return s + (k.menge || 0) * preis;
  }, 0);
  const kryptoKosten = kryptoPos.reduce((s, k) => s + (k.menge || 0) * (k.kaufkurs || 0), 0);
  const immoWert    = immobilien.reduce((s, p) => s + (p.aktueller_wert || 0), 0);
  const immoKosten  = immobilien.reduce((s, p) => s + (p.kaufpreis || 0), 0);
  const liquidWert  = liquiditaet.reduce((s, l) => s + (l.betrag || 0), 0);

  const gesamtAktuell = etfWert + kryptoWert + immoWert + liquidWert;
  const gesamtKosten  = etfKosten + kryptoKosten + immoKosten + liquidWert;
  const gesamtRendite = gesamtKosten > 0 ? ((gesamtAktuell - gesamtKosten) / gesamtKosten) * 100 : 0;
  const gesamtGewinn  = gesamtAktuell - gesamtKosten;

  // Asset-Performance
  const assetPerf = [
    { label: "ETF & Aktien", aktuell: etfWert, kosten: etfKosten, farbe: "#2563eb" },
    { label: "Krypto",       aktuell: kryptoWert, kosten: kryptoKosten, farbe: "#f59e0b" },
    { label: "Immobilien",   aktuell: immoWert, kosten: immoKosten, farbe: "#0d9488" },
    { label: "Liquidität",   aktuell: liquidWert, kosten: liquidWert, farbe: "#16a34a" },
  ].filter(a => a.kosten > 0);

  // MSCI World Benchmark (historisch ~7-10% p.a. – Richtwert)
  const benchmarkRendite = 8.5; // MSCI World 2026 Schätzung

  async function analyze() {
    setAiLoading(true); setAiText("");
    const perf = assetPerf.map(a => `${a.label}: Kaufwert ${fmtEur(a.kosten)}, aktuell ${fmtEur(a.aktuell)}, Rendite ${a.kosten > 0 ? ((a.aktuell-a.kosten)/a.kosten*100).toFixed(1) : 0}%`).join("; ");
    const text = await askAI(
      `Analysiere diese Portfolio-Performance:
${perf}
Gesamtrendite: ${gesamtRendite.toFixed(2)}%
Gewinn/Verlust: ${fmtEur(gesamtGewinn)}
MSCI World Benchmark: ~${benchmarkRendite}% p.a. (Referenz)
Gib eine ehrliche Einschätzung: 1) Schlägt das Portfolio den MSCI World? 2) Was performt am besten/schlechtesten? 3) Handlungsempfehlung. Max 4 Sätze.`,
      "Du bist ein hilfreicher KI-Assistent für Finanzthemen. Antworte auf Deutsch, direkt und ohne Markdown. Keine Anlageberatung."
    );
    setAiText(text); setAiLoading(false);
  }

  return (
    <div>
      <div style={{ padding: "10px 16px", background: "var(--surface2)", borderRadius: 8, border: "1px solid var(--border)", fontSize: 12, color: "var(--text3)", marginBottom: 20 }}>
        📌 Performance basiert auf Kaufpreisen und aktuellen Werten. ETF/Aktien-Kurse sind statisch hinterlegt – für Live-Kurse Alpha Vantage Key benötigt. Krypto via CoinGecko.
      </div>

      <div className="g4" style={{ marginBottom: 20 }}>
        <div className="metric"><div className="metric-label">Gesamtwert</div><div className="metric-value c-teal">{fmtEur(gesamtAktuell)}</div></div>
        <div className="metric"><div className="metric-label">Investiert</div><div className="metric-value c-text">{fmtEur(gesamtKosten)}</div></div>
        <div className="metric"><div className="metric-label">Gewinn/Verlust</div><div className="metric-value" style={{ color: gesamtGewinn >= 0 ? "var(--green)" : "var(--red)" }}>{gesamtGewinn >= 0 ? "+" : ""}{fmtEur(gesamtGewinn)}</div></div>
        <div className="metric">
          <div className="metric-label">Rendite gesamt</div>
          <div className="metric-value" style={{ color: gesamtRendite >= 0 ? "var(--green)" : "var(--red)" }}>{gesamtRendite >= 0 ? "+" : ""}{gesamtRendite.toFixed(2)} %</div>
          <div className="metric-sub">vs. MSCI World ~{benchmarkRendite}%/Jahr</div>
        </div>
      </div>

      <div className="g2" style={{ marginBottom: 16 }}>
        <div className="card">
          <div className="card-title"><span className="ct-icon">📊</span>Performance nach Asset-Klasse</div>
          {assetPerf.length === 0 ? (
            <div className="empty">Noch keine Daten</div>
          ) : (
            assetPerf.map(a => {
              const rendite = a.kosten > 0 ? ((a.aktuell - a.kosten) / a.kosten) * 100 : 0;
              const gewinn  = a.aktuell - a.kosten;
              return (
                <div className="row-item" key={a.label}>
                  <div>
                    <div className="row-label">{a.label}</div>
                    <div className="row-sub">Investiert: {fmtEur(a.kosten)} · Aktuell: {fmtEur(a.aktuell)}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: rendite >= 0 ? "var(--green)" : "var(--red)" }}>
                      {rendite >= 0 ? "+" : ""}{rendite.toFixed(1)} %
                    </div>
                    <div style={{ fontSize: 12, color: gewinn >= 0 ? "var(--green)" : "var(--red)" }}>
                      {gewinn >= 0 ? "+" : ""}{fmtEur(gewinn)}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="card">
          <div className="card-title"><span className="ct-icon">🎯</span>Benchmark-Vergleich</div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 8 }}>Mein Portfolio</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: gesamtRendite >= 0 ? "var(--green)" : "var(--red)", marginBottom: 4 }}>
              {gesamtRendite >= 0 ? "+" : ""}{gesamtRendite.toFixed(2)} %
            </div>
            <div className="alloc-bar" style={{ height: 10 }}>
              <div className="alloc-fill" style={{ width: `${Math.min(Math.abs(gesamtRendite) / 20 * 100, 100)}%`, background: gesamtRendite >= 0 ? "var(--green)" : "var(--red)" }} />
            </div>
          </div>
          <div>
            <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 8 }}>MSCI World (Referenz, historisch)</div>
            <div style={{ fontSize: 24, fontWeight: 700, color: "var(--teal)", marginBottom: 4 }}>+{benchmarkRendite} %/Jahr</div>
            <div className="alloc-bar" style={{ height: 10 }}>
              <div className="alloc-fill" style={{ width: `${(benchmarkRendite / 20) * 100}%`, background: "var(--teal)" }} />
            </div>
          </div>
          <hr className="divider" />
          <div style={{ fontSize: 13, color: "var(--text2)", padding: "8px 0" }}>
            {gesamtRendite >= benchmarkRendite
              ? `✅ Du schlägst den MSCI World um ${(gesamtRendite - benchmarkRendite).toFixed(1)} Prozentpunkte.`
              : `📌 MSCI World liegt ${(benchmarkRendite - gesamtRendite).toFixed(1)} Punkte vorne – typisch bei Immobilien & Krypto-Mix.`}
          </div>
          <button className="btn btn-ghost btn-sm" style={{ width: "100%", marginTop: 8 }} onClick={analyze} disabled={aiLoading}>
            {aiLoading ? <span className="dots">KI analysiert</span> : "🤖 KI-Einschätzung"}
          </button>
          {aiText && <div className="ai-box" style={{ marginTop: 12 }}><div className="ai-label">🤖 Performance-Analyse</div>{aiText}</div>}
        </div>
      </div>
    </div>
  );
}

// ── FIRE RECHNER ──────────────────────────────────────────────────────────────
function FIRErechner({ user, isPro }) {
  const { data: immobilien }  = useUserData("immobilien", user?.id);
  const { data: etfPos }      = useUserData("etf_positionen", user?.id);
  const { data: kryptoPos }   = useUserData("krypto_positionen", user?.id);
  const { data: liquiditaet } = useUserData("liquiditaet", user?.id);
  const { preise: kryptoPreise } = useKryptoLiveForPositionen(kryptoPos);

  const [monatsBedarf, setMonatsBedarf] = useState(3000);
  const [sparrate, setSparrate]         = useState(1000);
  const [alter, setAlter]               = useState(35);
  const [horizont, setHorizont]         = useState(30);
  const [rendite, setRendite]           = useState(7);
  const [volatilitaet, setVolatilitaet] = useState(15);
  const [inflation, setInflation]       = useState(2);
  const [result, setResult]             = useState(null);
  const [running, setRunning]           = useState(false);
  const [aiText, setAiText]             = useState("");
  const [aiLoading, setAiLoading]       = useState(false);

  const immoNettoWert = immobilien.reduce((s, p) => s + (p.aktueller_wert||0) - (p.restschuld||0), 0);
  const etfWert       = etfPos.reduce((s, e) => s + (e.anteile||0) * (e.kaufkurs||0), 0);
  const kryptoWert    = kryptoPos.reduce((s, k) => {
    const preis = k.cg_id && kryptoPreise[k.cg_id] ? kryptoPreise[k.cg_id] : (k.kaufkurs||0);
    return s + (k.menge||0) * preis;
  }, 0);
  const liquidWert = liquiditaet.reduce((s, l) => s + (l.betrag||0), 0);
  const gesamtWert = immoNettoWert + etfWert + kryptoWert + liquidWert;
  const fireZahl4pct = monatsBedarf * 12 * 25;
  const fortschritt  = gesamtWert > 0 ? Math.min((gesamtWert / fireZahl4pct) * 100, 100) : 0;

  function randNormal(mean, std) {
    let u = 0, v = 0;
    while (u === 0) u = Math.random();
    while (v === 0) v = Math.random();
    return mean + std * Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
  }

  function runSimulation() {
    setRunning(true);
    setTimeout(() => {
      const mu = rendite / 100;
      const sig = volatilitaet / 100;
      const inf = inflation / 100;
      const yrs = horizont;
      const n = 5000;
      let success = 0;
      const endwerte = [];
      const allPfade = [];

      for (let i = 0; i < n; i++) {
        let portfolio = gesamtWert;
        let entnahme  = monatsBedarf * 12;
        const pfad = [portfolio];
        let alive = true;
        for (let y = 0; y < yrs; y++) {
          const ret  = randNormal(mu, sig);
          const inf2 = randNormal(inf, 0.01);
          entnahme  *= (1 + inf2);
          portfolio  = portfolio * (1 + ret) + sparrate * 12 - (portfolio >= fireZahl4pct ? entnahme : 0);
          if (portfolio <= 0) { portfolio = 0; alive = false; pfad.push(0); break; }
          pfad.push(portfolio);
        }
        if (alive) success++;
        endwerte.push(portfolio);
        allPfade.push(pfad);
      }

      endwerte.sort((a, b) => a - b);
      allPfade.sort((a, b) => (a[a.length-1]||0) - (b[b.length-1]||0));
      const idx = (pct) => Math.floor(n * pct);

      setResult({
        successRate: (success / n) * 100,
        p10: endwerte[idx(0.10)], p25: endwerte[idx(0.25)],
        p50: endwerte[idx(0.50)], p75: endwerte[idx(0.75)],
        p90: endwerte[idx(0.90)],
        pfade: {
          p10: allPfade[idx(0.10)], p25: allPfade[idx(0.25)],
          p50: allPfade[idx(0.50)], p75: allPfade[idx(0.75)],
          p90: allPfade[idx(0.90)],
        }
      });
      setRunning(false);
    }, 50);
  }

  function rateColor(r) { return r >= 90 ? "var(--green)" : r >= 75 ? "var(--amber)" : "var(--red)"; }
  function rateLabel(r) { return r >= 90 ? "🟢 Sehr sicher" : r >= 75 ? "🟡 Akzeptabel" : r >= 60 ? "🟠 Riskant" : "🔴 Zu riskant"; }

  function PfadeChart({ pfade, years }) {
    if (!pfade || !pfade.p50) return null;
    const W = 340, H = 160, PAD = 32;
    const allVals = [...(pfade.p10||[]), ...(pfade.p90||[])].filter(v => v > 0);
    const maxV = Math.max(...allVals, 1);
    const toX = i => PAD + (i / years) * (W - PAD * 2);
    const toY = v => H - PAD - Math.min(v / maxV, 1) * (H - PAD * 2);
    function pathD(arr) {
      if (!arr || arr.length < 2) return "";
      return arr.map((v, i) => (i === 0 ? "M" : "L") + toX(i).toFixed(1) + "," + toY(v).toFixed(1)).join(" ");
    }
    function bandPath(lo, hi) {
      if (!lo || !hi) return "";
      const fwd = hi.map((v, i) => (i===0?"M":"L")+toX(i).toFixed(1)+","+toY(v).toFixed(1)).join(" ");
      const bwd = [...lo].reverse().map((v, i) => "L"+toX(lo.length-1-i).toFixed(1)+","+toY(v).toFixed(1)).join(" ");
      return fwd + " " + bwd + " Z";
    }
    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height: H }}>
        <path d={bandPath(pfade.p25, pfade.p75)} fill="var(--teal)" opacity="0.12" />
        <path d={pathD(pfade.p10)} fill="none" stroke="var(--red)" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.7" />
        <path d={pathD(pfade.p90)} fill="none" stroke="var(--green)" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.7" />
        <path d={pathD(pfade.p25)} fill="none" stroke="var(--teal)" strokeWidth="1.5" opacity="0.5" />
        <path d={pathD(pfade.p75)} fill="none" stroke="var(--teal)" strokeWidth="1.5" opacity="0.5" />
        <path d={pathD(pfade.p50)} fill="none" stroke="var(--teal)" strokeWidth="2.5" />
        <line x1={PAD} y1={toY(fireZahl4pct)} x2={W-PAD} y2={toY(fireZahl4pct)} stroke="var(--amber)" strokeWidth="1.5" strokeDasharray="5,4" />
        <text x={W-PAD+2} y={toY(fireZahl4pct)+4} fontSize="9" fill="var(--amber)">Ziel</text>
        <text x={PAD} y={H-4} fontSize="9" fill="var(--text3)">Heute</text>
        <text x={W-PAD-12} y={H-4} fontSize="9" fill="var(--text3)">{years}J.</text>
      </svg>
    );
  }

  async function analyze() {
    if (!result) return;
    setAiLoading(true); setAiText("");
    const text = await askAI(
      "Monte Carlo FIRE-Analyse:\nAlter: " + alter + ", Horizont: " + horizont + " Jahre\nStartkapital: " + fmtEur(gesamtWert) + ", FIRE-Ziel: " + fmtEur(fireZahl4pct) + "\nEntnahme: " + fmtEur(monatsBedarf) + "/Mo, Sparrate: " + fmtEur(sparrate) + "/Mo\nRendite: " + rendite + "% ± " + volatilitaet + "% Vola, Inflation: " + inflation + "%\nErfolgsrate: " + result.successRate.toFixed(1) + "%\nMedian-Endvermögen: " + fmtEur(result.p50) + "\nP10: " + fmtEur(result.p10) + " | P90: " + fmtEur(result.p90) + "\nBewerte Erfolgsrate, erkläre Sequence-of-Returns-Risiko, gib 2 konkrete Optimierungstipps. Max 5 Sätze. Deutsch, kein Markdown.",
      "Du bist FIRE-Experte. Antworte auf Deutsch, ohne Markdown."
    );
    setAiText(text); setAiLoading(false);
  }

  const FIRE_TYPEN = [
    { name: "Lean FIRE", zahl: monatsBedarf * 0.7 * 12 * 25, farbe: "var(--amber)" },
    { name: "Regular FIRE", zahl: fireZahl4pct, farbe: "var(--teal)" },
    { name: "Fat FIRE", zahl: fireZahl4pct * 2, farbe: "var(--purple)" },
  ];

  return (
    <div>
      <div className="card" style={{ marginBottom: 16, background: "linear-gradient(135deg, #0a1f1e, #0d2d2a)", color: "white", border: "none" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6 }}>Monte Carlo FIRE-Simulation</div>
            <div style={{ fontFamily: "Lora, serif", fontSize: 22, fontWeight: 600, color: "white", marginBottom: 4 }}>Wie sicher ist dein FIRE-Plan?</div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.55)" }}>5.000 Szenarien · Rendite-Volatilität · Inflation · Sequence-of-Returns</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginBottom: 2 }}>Dein Vermögen</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: "var(--teal-light)" }}>{fmtEur(gesamtWert)}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>FIRE-Ziel: {fmtEur(fireZahl4pct)}</div>
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "rgba(255,255,255,0.5)", marginBottom: 6 }}>
            <span>Fortschritt</span><span>{fortschritt.toFixed(1)}%</span>
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,0.1)", borderRadius: 3 }}>
            <div style={{ height: "100%", width: fortschritt + "%", background: "var(--teal)", borderRadius: 3 }} />
          </div>
        </div>
      </div>

      <div className="g2" style={{ marginBottom: 16 }}>
        <div className="card">
          <div className="card-title"><span className="ct-icon">⚙️</span>Simulationsparameter</div>
          <div style={{ fontSize: 11, color: "var(--text3)", textTransform: "uppercase", fontWeight: 700, marginBottom: 10 }}>Persönlich</div>
          {[
            { label: "Monatlicher Bedarf (€)", val: monatsBedarf, set: setMonatsBedarf, step: 100 },
            { label: "Monatliche Sparrate (€)", val: sparrate, set: setSparrate, step: 100 },
            { label: "Aktuelles Alter", val: alter, set: setAlter, step: 1 },
            { label: "Horizont (Jahre)", val: horizont, set: setHorizont, step: 1 },
          ].map(f => (
            <div className="field" key={f.label}>
              <label className="label">{f.label}</label>
              <input className="input" type="number" step={f.step} value={f.val} onChange={e => f.set(+e.target.value||0)} />
            </div>
          ))}
          <hr className="divider" />
          <div style={{ fontSize: 11, color: "var(--text3)", textTransform: "uppercase", fontWeight: 700, marginBottom: 10 }}>Marktparameter</div>
          {[
            { label: "Rendite p.a. (%)", val: rendite, set: setRendite, hint: "MSCI World real: ~6–8%", step: 0.5 },
            { label: "Volatilität (%)", val: volatilitaet, set: setVolatilitaet, hint: "Aktien ~15–20% | Misch ~10%", step: 1 },
            { label: "Inflation p.a. (%)", val: inflation, set: setInflation, hint: "Historisch ~2%", step: 0.5 },
          ].map(f => (
            <div className="field" key={f.label}>
              <label className="label">{f.label}</label>
              <input className="input" type="number" step={f.step} value={f.val} onChange={e => f.set(+e.target.value||0)} />
              {f.hint && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 3 }}>{f.hint}</div>}
            </div>
          ))}
          <button className="btn btn-primary" style={{ width: "100%", marginTop: 8, fontSize: 14, padding: "11px" }}
            onClick={runSimulation} disabled={running}>
            {running ? <span className="dots">Simuliere 5.000 Szenarien</span> : "🎲 Monte Carlo starten"}
          </button>
        </div>

        <div>
          {!result ? (
            <div className="card" style={{ textAlign: "center", padding: "40px 24px" }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>🎲</div>
              <div style={{ fontFamily: "Lora, serif", fontSize: 17, fontWeight: 600, marginBottom: 8 }}>Monte Carlo Simulation</div>
              <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.65 }}>
                5.000 zufällige Marktszenarien zeigen dir wie wahrscheinlich dein FIRE-Plan über {horizont} Jahre erfolgreich ist.
              </div>
            </div>
          ) : (
            <>
              <div className="card" style={{ textAlign: "center", marginBottom: 12, border: "2px solid " + rateColor(result.successRate) }}>
                <div style={{ fontSize: 11, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>Erfolgswahrscheinlichkeit</div>
                <div style={{ fontSize: 56, fontWeight: 800, color: rateColor(result.successRate), lineHeight: 1 }}>{result.successRate.toFixed(1)}%</div>
                <div style={{ fontSize: 14, color: "var(--text2)", marginTop: 6 }}>{rateLabel(result.successRate)}</div>
                <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 4 }}>Portfolio hält {horizont} Jahre in {result.successRate.toFixed(0)}% aller Szenarien</div>
                <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 8, paddingTop: 8, borderTop: "1px solid var(--border)" }}>Ziel: ≥90% konservativ · ≥80% akzeptabel</div>
              </div>

              <div className="card" style={{ marginBottom: 12, padding: "16px 12px" }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text2)", marginBottom: 8 }}>Portfolioentwicklung · {horizont} Jahre</div>
                <PfadeChart pfade={result.pfade} years={horizont} />
                <div style={{ display: "flex", gap: 10, marginTop: 8, flexWrap: "wrap" }}>
                  {[{ l: "P90", c: "var(--green)" }, { l: "P75/P25", c: "var(--teal)" }, { l: "Median", c: "var(--teal)" }, { l: "P10", c: "var(--red)" }].map(x => (
                    <div key={x.l} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, color: "var(--text3)" }}>
                      <div style={{ width: 14, height: 2, background: x.c }} />{x.l}
                    </div>
                  ))}
                </div>
              </div>

              <div className="card" style={{ marginBottom: 12 }}>
                <div className="card-title" style={{ fontSize: 12 }}><span className="ct-icon">📊</span>Endvermögen nach {horizont} Jahren</div>
                {[
                  { label: "P90 – Gutes Szenario", val: result.p90, color: "var(--green)" },
                  { label: "P75 – Überdurchschnittlich", val: result.p75, color: "var(--green)" },
                  { label: "P50 – Median", val: result.p50, color: "var(--teal)" },
                  { label: "P25 – Unterdurchschnittlich", val: result.p25, color: "var(--amber)" },
                  { label: "P10 – Schlechtes Szenario", val: result.p10, color: "var(--red)" },
                ].map(row => (
                  <div key={row.label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--border)", fontSize: 13 }}>
                    <span style={{ color: "var(--text2)" }}>{row.label}</span>
                    <span style={{ fontWeight: 700, color: row.color }}>{row.val > 0 ? fmtEur(row.val) : "💀 Pleite"}</span>
                  </div>
                ))}
              </div>

              {isPro && (
                <div className="card">
                  <button className="btn btn-ghost btn-sm" style={{ width: "100%" }} onClick={analyze} disabled={aiLoading}>
                    {aiLoading ? <span className="dots">KI analysiert</span> : "🤖 KI-FIRE-Analyse (PRO)"}
                  </button>
                  {aiText && <div className="ai-box" style={{ marginTop: 12 }}><div className="ai-label">🤖 Monte Carlo Analyse</div>{aiText}</div>}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="g2">
        <div className="card">
          <div className="card-title"><span className="ct-icon">🔥</span>FIRE-Varianten</div>
          {FIRE_TYPEN.map(ft => {
            const pct = Math.min((gesamtWert / ft.zahl) * 100, 100);
            return (
              <div key={ft.name} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: ft.farbe }}>{ft.name}</span>
                  <span style={{ fontSize: 12, color: "var(--text3)" }}>{fmtEur(ft.zahl)} · {pct.toFixed(0)}%</span>
                </div>
                <div className="alloc-bar"><div className="alloc-fill" style={{ width: pct + "%", background: ft.farbe }} /></div>
              </div>
            );
          })}
        </div>
        <div className="card">
          <div className="card-title"><span className="ct-icon">⚠️</span>Sequence-of-Returns Risiko</div>
          <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.7, marginBottom: 12 }}>
            Das größte FIRE-Risiko: Ein starker Markteinbruch <strong>direkt nach dem FIRE-Datum</strong> kann dein Portfolio dauerhaft schädigen – selbst wenn die Märkte danach stark erholen.
          </div>
          {["2–3 Jahre Cash-Puffer halten", "Variable Entnahme: in Krisenjahren weniger entnehmen", "Guardrails: Entnahme bei -20% Portfolio reduzieren", "Diversifikation: Dividenden + Mieteinnahmen stabilisieren"].map((tip, i) => (
            <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8, fontSize: 13 }}>
              <span style={{ color: "var(--teal)", fontWeight: 700, flexShrink: 0 }}>→</span>
              <span style={{ color: "var(--text2)" }}>{tip}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
